import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import { useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { API_BASE_URL } from '../config/apiConfig';

const SESSION_CART_KEY = 'ccc_guest_cart';
const SESSION_WISHLIST_KEY = 'ccc_guest_wishlist';
const SESSION_RETURN_KEY = 'ccc_return_to';

const ALLOWED_STYLES = [
  'cuff',
  'front',
  'pocket',
  'yoke',
  'hem',
  'buttons',
  'buttonholes',
  'collar',
  'collarcuffstitching',
  'sleeveplacketbutton',
  'adjustablecuffbutton'
];

const STYLE_DISPLAY_ORDER = [
  'collar',
  'cuff',
  'front',
  'pocket',
  'yoke',
  'hem',
  'buttons'
];

const POST_ACCENT_STYLE_ORDER = [
  'buttonholes',
  'collarcuffstitching',
  'sleeveplacketbutton',
  'adjustablecuffbutton'
];

const STYLE_DISPLAY_LABELS = {
  cuff: 'Cuff/Sleeve',
  front: 'Front/Placket',
  pocket: 'Pocket',
  yoke: 'Yoke',
  hem: 'Bottom Hem',
  buttons: 'Buttons',
  buttonholes: 'Button Holes',
  collar: 'Collar',
  collarcuffstitching: 'Collar / Cuff Stitching',
  sleeveplacketbutton: 'Sleeve Placket Button',
  adjustablecuffbutton: 'Adjustable Cuff Button'
};
// const fabricSlides = [
//     '/assets/images/white-checks-resize.jpg',
//     '/assets/images/green-checks-resize.jpg',
//     '/assets/images/proper-cloth-shirt-removebg-preview.png',
//   ];

const Customize = () => {
  const { id } = useParams();
  const [productData, setProductData] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [activeTab, setActiveTab] = useState('Fabric');
  const [selectedFabricIndex, setSelectedFabricIndex] = useState(0);
  const [selectedProfile, setSelectedProfile] = useState('No Style Profile Selected');
  const [selectedStyleIDs, setSelectedStyleIDs] = useState({});
  const leftSectionRef = useRef(null);
  const rightSectionRef = useRef(null);
  const [productPrice, setProductPrice] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
const slidesRef = useRef(null);
// const [showMeasurePopup, setShowMeasurePopup] = useState(false);
const [showMeasureShirtPopup, setShowMeasureShirtPopup] = useState(false);
const [showMailUsPopup, setShowMailUsPopup] = useState(false);
const [fit, setFit] = useState('slim');
const [shirtFit, setShirtFit] = useState('slim');
 const navigate = useNavigate();
 const location = useLocation();

const [fitDropdownOpen, setFitDropdownOpen] = useState(false);
const [shirtDropdownOpen, setShirtDropdownOpen] = useState(false);
const [selectedSmartSizeId, setSelectedSmartSizeId] = useState(null);

const [selectedSizeType, setSelectedSizeType] = useState(null); // 'smart' | 'body' | 'shirt' | 'mail'
const [selectedSizeId, setSelectedSizeId] = useState(null);
const [showSizePanel, setShowSizePanel] = useState(true);

const [bodyMeasurements, setBodyMeasurements] = useState([]);
const [editingBodyMeasurement, setEditingBodyMeasurement] = useState(null);
const [selectedBodyMeasurementId, setSelectedBodyMeasurementId] = useState(null);
const [showMeasurePopup, setShowMeasurePopup] = useState(false);

const [shirtMeasurements, setShirtMeasurements] = useState([]);
const [selectedShirtMeasurement, setSelectedShirtMeasurement] = useState(null);
const [showShirtPopup, setShowShirtPopup] = useState(false);
const [shirtForm, setShirtForm] = useState({
  collarAround: '',
  sleeveLength: '',
  yokeWidth: '',
  chestWidth: '',
  midsectionWidth: '',
  shirtLength: '',
  sleeveWidth: '',
  cuffAround: ''
});

// const [selectedSizeType, setSelectedSizeType] = useState(null);
// const [selectedSizeId, setSelectedSizeId] = useState(null);

const [selectedSleeveGroup, setSelectedSleeveGroup] = useState({});
const [activeStyleType, setActiveStyleType] = useState(null);
const [showAdvancedStyleMenus, setShowAdvancedStyleMenus] = useState(false);

const [isMonogramEnabled, setIsMonogramEnabled] = useState(false);
const [monogramInitials, setMonogramInitials] = useState('');
const [monogramStyle, setMonogramStyle] = useState('Block');
const [monogramColor, setMonogramColor] = useState('Black');
const [monogramPlacement, setMonogramPlacement] = useState('Left Center Cuff');

const [isStyleDropdownOpen, setIsStyleDropdownOpen] = useState(false);

const [deliveryEstimate, setDeliveryEstimate] = useState('');
const [showSizeGuide, setShowSizeGuide] = useState(false);
const [selectedSizeGuideFit, setSelectedSizeGuideFit] = useState('Slim');
const [selectedSizeGuideTableData, setSelectedSizeGuideTableData] = useState([]);


const [isCollarAccentEnabled, setIsCollarAccentEnabled] = useState(false);
const [isCuffAccentEnabled, setIsCuffAccentEnabled] = useState(false);
const [selectedAccentFabricId, setSelectedAccentFabricId] = useState(null);
const [accentFabrics, setAccentFabrics] = useState([]);
const [collarAccentImage, setCollarAccentImage] = useState(null);

// Button overlays for collar/cuff/front, computed from previewImages[].buttonOverlays
const [buttonOverlayImages, setButtonOverlayImages] = useState({});
// Button-hole overlays for collar/cuff/front/pocket
const [buttonHoleOverlayImages, setButtonHoleOverlayImages] = useState({});

// Tracks the currently-chosen Collar name (for the “Unavailable for …” text)
const [selectedCollarName, setSelectedCollarName] = useState(null);

const safeParse = (raw, fallback) => {
  try { return raw ? JSON.parse(raw) : fallback; } catch { return fallback; }
};

const toNullableNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const getGuestCart = () => safeParse(sessionStorage.getItem(SESSION_CART_KEY), []);
const setGuestCart = (items) => {
  try { sessionStorage.setItem(SESSION_CART_KEY, JSON.stringify(items || [])); } catch {}
  window.dispatchEvent(new Event('ccc_cart_updated'));
};

const addGuestCartItem = (item) => {
  const list = getGuestCart();
  const next = [{ ...item, guestCartId: item.guestCartId || (crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`) }, ...(list || [])];
  setGuestCart(next);
};

const getGuestWishlist = () => safeParse(sessionStorage.getItem(SESSION_WISHLIST_KEY), []);
const setGuestWishlist = (items) => {
  try { sessionStorage.setItem(SESSION_WISHLIST_KEY, JSON.stringify(items || [])); } catch {}
  window.dispatchEvent(new Event('ccc_wishlist_updated'));
};

const addGuestWishlistItem = (item) => {
  const list = getGuestWishlist();
  const exists = (list || []).some(
    (x) =>
      String(x.productId) === String(item.productId) &&
      String(x.fabricId) === String(item.fabricId) &&
      String(x.sizeType) === String(item.sizeType) &&
      String(x.sizeId) === String(item.sizeId)
  );
  if (exists) return;
  const next = [{ ...item, guestWishlistId: item.guestWishlistId || (crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`) }, ...(list || [])];
  setGuestWishlist(next);
};


// --- Loading UI for left preview ---
const [pendingOptions, setPendingOptions] = useState(null); // stage new layer URLs here
const [isPreviewLoading, setIsPreviewLoading] = useState(false);
const [loadProgress, setLoadProgress] = useState(0);
const [isRightFabricReady, setIsRightFabricReady] = useState(false);
const [isRightStylesReady, setIsRightStylesReady] = useState(false);
const [shouldStageRightLoad, setShouldStageRightLoad] = useState(true);

// const token = localStorage.getItem('token');

// const numericUserId = useMemo(() => {
//   const id = user?.userId;
//   return id ? parseInt(id, 10) : null;
// }, [user]);

// ✅ USER MUST BE DEFINED BEFORE IT'S USED ANYWHERE
const [user, setUser] = useState(() => {
  try {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
});

const token = localStorage.getItem('token');

const numericUserId = useMemo(() => {
  const id = user?.userId;
  return id ? parseInt(id, 10) : null;
}, [user]);

// Measurement Videos
const [bodyVideos, setBodyVideos] = useState({});
const [shirtVideos, setShirtVideos] = useState({});

// Which field is currently selected in each popup
const [activeBodyField, setActiveBodyField] = useState('neckAround');
const [activeShirtField, setActiveShirtField] = useState('collarAround');

const toEmbedUrl = (video) => {
  if (!video) return '';

  // CASE 1: API returns a string URL
  if (typeof video === 'string') {
    const raw = video.trim();
    if (!raw) return '';
    if (raw.includes('/embed/')) return raw;

    try {
      const url = new URL(raw);

      if (url.hostname.includes('youtu.be')) {
        const id = url.pathname.replace('/', '').trim();
        return id ? `https://www.youtube.com/embed/${id}` : '';
      }

      const v = url.searchParams.get('v');
      if (v) return `https://www.youtube.com/embed/${v}`;

      if (url.pathname.includes('/shorts/')) {
        const id = url.pathname.split('/shorts/')[1]?.split(/[?/]/)[0];
        return id ? `https://www.youtube.com/embed/${id}` : '';
      }

      const parts = url.pathname.split('/').filter(Boolean);
      const maybeId = parts[parts.length - 1];
      return maybeId ? `https://www.youtube.com/embed/${maybeId}` : '';
    } catch {
      const cleaned = raw.replace(/\s/g, '');
      if (cleaned.length >= 6 && !cleaned.includes('http')) {
        return `https://www.youtube.com/embed/${cleaned}`;
      }
      return '';
    }
  }

  // CASE 2: API returns an object
  if (video.embedUrl && String(video.embedUrl).trim()) {
    return String(video.embedUrl).trim();
  }

  const raw =
    (video.videoUrl && String(video.videoUrl).trim()) ||
    (video.youtubeId && `https://www.youtube.com/watch?v=${String(video.youtubeId).trim()}`) ||
    '';

  if (!raw) return '';
  if (raw.includes('/embed/')) return raw;

  try {
    const url = new URL(raw);

    if (url.hostname.includes('youtu.be')) {
      const id = url.pathname.replace('/', '').trim();
      return id ? `https://www.youtube.com/embed/${id}` : '';
    }

    const v = url.searchParams.get('v');
    if (v) return `https://www.youtube.com/embed/${v}`;

    if (url.pathname.includes('/shorts/')) {
      const id = url.pathname.split('/shorts/')[1]?.split(/[?/]/)[0];
      return id ? `https://www.youtube.com/embed/${id}` : '';
    }

    const parts = url.pathname.split('/').filter(Boolean);
    const maybeId = parts[parts.length - 1];
    return maybeId ? `https://www.youtube.com/embed/${maybeId}` : '';
  } catch {
    const cleaned = raw.replace(/\s/g, '');
    if (cleaned.length >= 6 && !cleaned.includes('http')) {
      return `https://www.youtube.com/embed/${cleaned}`;
    }
    return '';
  }
};

useEffect(() => {
  const loadMeasurementVideos = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/measurement-videos`);
      const data = await res.json();

      // Expecting: { Body: {...}, Shirt: {...} }
      setBodyVideos(data?.Body || {});
      setShirtVideos(data?.Shirt || {});
    } catch (e) {
      console.error('Failed to load measurement videos', e);
      setBodyVideos({});
      setShirtVideos({});
    }
  };

  loadMeasurementVideos();
}, []);

const BODY_FIELD_LABELS = {
  neckAround: 'Neck Around',
  sleeveLength: 'Sleeve Length',
  shoulderWidth: 'Shoulder Width',
  chestAround: 'Chest Around',
  waistAround: 'Waist Around',
  shirtLength: 'Shirt Length',
  bicepAround: 'Bicep Around',
  wristAround: 'Wrist Around',
};

const SHIRT_FIELD_LABELS = {
  collarAround: 'Collar Around',
  sleeveLength: 'Sleeve Length',
  yokeWidth: 'Yoke Width',
  chestWidth: 'Chest Width',
  midsectionWidth: 'Midsection Width',
  shirtLength: 'Shirt Length',
  sleeveWidth: 'Sleeve Width',
  cuffAround: 'Cuff Around',
};

const getBodyVideoUrl = () => toEmbedUrl(bodyVideos?.[activeBodyField]);
const getShirtVideoUrl = () => toEmbedUrl(shirtVideos?.[activeShirtField]);


// ---------- STANDARD SIZES ----------
// ---------- GUEST STANDARD SIZE STORAGE ----------
const GUEST_STD_LIST_KEY = 'ccc_guest_standard_sizes';
const GUEST_STD_SELECTED_KEY = 'ccc_guest_selected_size'; // store selection for Summary/Add-to-cart later
const GUEST_SIZE_KEY = 'ccc_guest_size';

const getGuestStandardSizes = () => safeParse(sessionStorage.getItem(GUEST_STD_LIST_KEY), []);
const setGuestStandardSizes = (list) => {
  try { sessionStorage.setItem(GUEST_STD_LIST_KEY, JSON.stringify(list || [])); } catch {}
};

const saveGuestSize = (payload) => {
  try { sessionStorage.setItem(GUEST_SIZE_KEY, JSON.stringify(payload)); } catch {}
  window.dispatchEvent(new Event('ccc_guest_size_updated'));
};

const setGuestSelectedSize = (payload) => {
  // payload example: { sizeType:'standard', sizeId:'guest_...', standardSizeData:{...} }
  try { sessionStorage.setItem(GUEST_STD_SELECTED_KEY, JSON.stringify(payload)); } catch {}
};
const getGuestSelectedSize = () => safeParse(sessionStorage.getItem(GUEST_STD_SELECTED_KEY), null);
const getGuestSizeSnapshot = () => safeParse(sessionStorage.getItem(GUEST_SIZE_KEY), null);


const [standardSize, setStandardSize] = useState({
  collarSize: '',
  sleeveLength: '',
  fit: ''
});

const [standardSizeList, setStandardSizeList] = useState([]);

const COLLAR_OPTIONS = [
  { value: '14.5', label: 'XS' },
  { value: '15', label: 'S' },
  { value: '15.5', label: 'M' },
  { value: '16', label: 'M/L' },
  { value: '16.5', label: 'L' },
  { value: '17', label: 'XL' },
  { value: '17.5', label: 'XL' },
  { value: '18', label: '2XL' },
  { value: '18.5', label: '2XL' },
  { value: '19', label: '3XL' },
  { value: '20', label: '4XL' },
  { value: '21', label: '5XL' }
];

// when collar is 14.5 or 15 → use 32–35
const SLEEVE_OPTIONS_SMALL_COLLAR = [
  { value: '32', label: `5'6"–5'8"` },
  { value: '33', label: `5'8"–5'9"` },
  { value: '34', label: `5'10"–5'11"` },
  { value: '35', label: `6'0"–6'1"` },
];

// when collar is 15.5 and above → use 33–36
const SLEEVE_OPTIONS_LARGE_COLLAR = [
  { value: '33', label: `5'8"–5'9"` },
  { value: '34', label: `5'10"–5'11"` },
  { value: '35', label: `6'0"–6'1"` },
  { value: '36', label: `6'2"–6'3"` },
];

const FIT_OPTIONS = [
  { value: 'Slim', label: 'Slim' },
  { value: 'Classic', label: 'Classic' },
  { value: 'Athletic', label: 'Athletic' }
];

const sizeGuideColumns = ["38", "40", "42", "44", "46", "48", "50"];

const sizeGuideRowLabels = [
  "Length(Back)",
  "Chest",
  "Stomach",
  "Hips",
  "Shoulder",
  "Sleeve",
  "Biceps",
  "Cuffs",
  "Neck"
];

const shirtSizeGuideData = {
  Slim: {
    "38": [28, 40, 38.5, 40, 17.5, 24.5, 14.5, 9.25, 14.75],
    "40": [29.5, 43, 40.5, 41.5, 17.75, 25.25, 15, 9.75, 16],
    "42": [30.5, 45, 42.5, 44, 18.25, 25.5, 15.5, 10.5, 16],
    "44": [30.5, 45, 44, 45, 18.5, 25.5, 15.5, 10.25, 16.75],
    "46": [31.5, 48.5, 46.5, 47.5, 19.25, 25.5, 17.5, 10.25, 16.75],
    "48": [33.5, 51, 49.5, 50.5, 19.5, 26.25, 16.5, 10.5, 17.25],
    "50": [34, 54, 50.5, 52, 20, 26, 18, 11, 17.75]
  },
  Athletic: {
    "38": [27.75, 42.5, 40.5, 42, 17.5, 24.5, 16, 9.5, 14.75],
    "40": [29, 44, 42.5, 43.5, 18, 24.75, 16.5, 10.75, 15.5],
    "42": [30, 45, 44.5, 46, 18.25, 25.14, 16.5, 10, 16],
    "44": [30, 48, 46.5, 47.5, 18.5, 25.75, 17.5, 10.25, 16.25],
    "46": [31.5, 50, 48.5, 49, 18.5, 25.25, 18, 10.5, 16.75],
    "48": [33, 52, 50.5, 50.5, 19.5, 26, 18.5, 10.5, 17.75],
    "50": [34, 54.5, 52, 54, 20, 26, 18.5, 11, 17.75]
  },
  Classic: {
    "38": [28, 41.5, 39, 41, 17.5, 24.75, 15, 9.5, 14.75],
    "40": [29, 42.5, 41, 42, 18, 24.5, 16, 9.75, 15.75],
    "42": [29.5, 44.5, 43, 44, 18.25, 25.25, 16, 10, 15.75],
    "44": [30.5, 47, 46, 46.5, 18.5, 25, 16.5, 10.5, 16.5],
    "46": [31.5, 50, 47, 48.5, 18.75, 25.5, 18, 10.5, 17],
    "48": [33, 50.5, 49, 50, 19, 26, 17.5, 10.5, 17.25],
    "50": [34, 53, 51.5, 52, 20, 26.25, 18.5, 11, 17.75]
  }
};

const [standardSizeSaved, setStandardSizeSaved] = useState(null);

const sleeveOptionsForCurrentCollar = useMemo(() => {
  const collar = parseFloat(standardSize.collarSize);
  if (!collar) {
    // default view – same as 15.5+ in your screenshots
    return SLEEVE_OPTIONS_LARGE_COLLAR;
  }

  // 14.5 or 15 → shorter sleeve set
  if (collar <= 15) {
    return SLEEVE_OPTIONS_SMALL_COLLAR;
  }

  // 15.5 and above → longer sleeve set
  return SLEEVE_OPTIONS_LARGE_COLLAR;
}, [standardSize.collarSize]);

useEffect(() => {
  if (!standardSize.sleeveLength) return;

  const stillValid = sleeveOptionsForCurrentCollar.some(
    opt => opt.value === standardSize.sleeveLength
  );

  if (!stillValid) {
    setStandardSize(prev => ({ ...prev, sleeveLength: '' }));
  }
}, [sleeveOptionsForCurrentCollar, standardSize.sleeveLength]);

useEffect(() => {
  // ✅ Guest mode: load from sessionStorage
  if (!numericUserId) {
    const guestList = getGuestStandardSizes();
    setStandardSizeList(Array.isArray(guestList) ? guestList : []);
    setStandardSizeSaved(null);
    setStandardSize({ collarSize: '', sleeveLength: '', fit: '' });

    // restore guest selected size if any
    const sel = getGuestSelectedSize();
    if (sel?.sizeType === 'standard' && sel?.sizeId) {
      setSelectedSizeType('standard');
      setSelectedSizeId(sel.sizeId);
      setShowSizePanel(false);
    }
    return;
  }

  // ✅ Logged-in mode: load from API
  fetch(`${API_BASE_URL}/UserManagement/GetStandardSizes/${numericUserId}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
    .then(res => (res.ok ? res.json() : null))
    .then(data => {
      if (!data) {
        setStandardSizeList([]);
        setStandardSizeSaved(null);
        setStandardSize({ collarSize: '', sleeveLength: '', fit: '' });
        return;
      }

      const list = Array.isArray(data) ? data : [data];
      setStandardSizeList(list);

      const record = list[0];
      if (!record || !record.standardSizeSelectionId) {
        setStandardSizeSaved(null);
        setStandardSize({ collarSize: '', sleeveLength: '', fit: '' });
        return;
      }

      setStandardSizeSaved(record);

      const normalize = (v) => (v === null || v === undefined ? '' : String(v).trim());
      setStandardSize({
        collarSize: normalize(record.collarSize),
        sleeveLength: normalize(record.sleeveLength),
        fit: normalize(record.fit),
      });
    })
    .catch(err => {
      console.error('Error loading standard size:', err);
      setStandardSizeList([]);
      setStandardSizeSaved(null);
      setStandardSize({ collarSize: '', sleeveLength: '', fit: '' });
    });
}, [numericUserId, token]);

useEffect(() => {
  if (numericUserId) return;

  const hydrateGuestSelection = () => {
    const guest = getGuestSizeSnapshot();
    setSmartSizes([]);
    setBodyMeasurements([]);
    setShirtMeasurements([]);
    if (!guest?.sizeType) return;

    const type = String(guest.sizeType).toLowerCase();

    if (type === 'body' && guest.body) {
      const guestBodyId = guest.sizeId || 'guest_body';
      setBodyMeasurements([{ bodyMeasurementId: guestBodyId, ...guest.body }]);
      setSelectedSizeType('body');
      setSelectedSizeId(guestBodyId);
      setShowSizePanel(false);
      return;
    }

    if (type === 'shirt' && guest.shirt) {
      const guestShirtId = guest.sizeId || 'guest_shirt';
      setShirtMeasurements([{ shirtMeasurementId: guestShirtId, ...guest.shirt }]);
      setSelectedSizeType('shirt');
      setSelectedSizeId(guestShirtId);
      setShowSizePanel(false);
      return;
    }

    if (type === 'smart') {
      const guestSmartId = guest.sizeId || 'guest_smart';
      setSmartSizes([{
        smartSizeId: guestSmartId,
        name: guest.smartSizeName || guest.smartSizeData?.name || 'Smart Size',
        ...(guest.smartSizeData || {})
      }]);
      setSelectedSizeType('smart');
      setSelectedSizeId(guestSmartId);
      setShowSizePanel(false);
    }
  };

  hydrateGuestSelection();
  window.addEventListener('ccc_guest_size_updated', hydrateGuestSelection);
  return () => window.removeEventListener('ccc_guest_size_updated', hydrateGuestSelection);
}, [numericUserId]);

const openSizeGuide = () => setShowSizeGuide(true);
const closeSizeGuide = () => setShowSizeGuide(false);

const handleSizeGuideFitChange = (fit) => {
  setSelectedSizeGuideFit(fit);
  const fitKey = fit;
  const fitRows = shirtSizeGuideData[fitKey] || shirtSizeGuideData.Slim;

  const rows = sizeGuideRowLabels.map((_, rowIndex) =>
    sizeGuideColumns.map((size) => (fitRows[size] ? fitRows[size][rowIndex] : '-'))
  );
  setSelectedSizeGuideTableData(rows);
};

useEffect(() => {
  handleSizeGuideFitChange('Slim');
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);



const handleStandardSelect = (key, value) => {
  setStandardSize(prev => ({ ...prev, [key]: value }));
};

const handleEditStandardSize = (record) => {
  if (!record) return;

  const normalize = (v) =>
    v === null || v === undefined ? '' : String(v).trim();

  setStandardSize({
    collarSize: normalize(record.collarSize),
    sleeveLength: normalize(record.sleeveLength),
    fit: normalize(record.fit),
  });

  setStandardSizeSaved(record);
};

const handleSaveStandardSize = async () => {
  // common validation
  if (!standardSize.collarSize || !standardSize.sleeveLength || !standardSize.fit) {
    alert('Please select Collar Size, Sleeve Length and Fit.');
    return;
  }

  // ✅ GUEST: save to sessionStorage
  if (!numericUserId) {
    const now = Date.now();
    const newItem = {
      standardSizeSelectionId: standardSizeSaved?.standardSizeSelectionId || `guest_${now}`,
      collarSize: String(standardSize.collarSize),
      sleeveLength: String(standardSize.sleeveLength),
      fit: String(standardSize.fit),
    };

    const current = getGuestStandardSizes();
    const exists = current.some(s => s.standardSizeSelectionId === newItem.standardSizeSelectionId);

    const updated = exists
      ? current.map(s => (s.standardSizeSelectionId === newItem.standardSizeSelectionId ? newItem : s))
      : [newItem, ...current];

    setGuestStandardSizes(updated);
    setStandardSizeList(updated);

    // auto-select
    setSelectedSizeType('standard');
    setSelectedSizeId(newItem.standardSizeSelectionId);
    setGuestSelectedSize({
      sizeType: 'standard',
      sizeId: newItem.standardSizeSelectionId,
      standardSizeData: newItem
    });
    setShowSizePanel(false);

    // reset form
    setStandardSizeSaved(null);
    setStandardSize({ collarSize: '', sleeveLength: '', fit: '' });

    alert('Standard size saved.');
    return;
  }

  // ✅ LOGGED-IN: save to API
  const standardSizeSelectionId = Number(standardSizeSaved?.standardSizeSelectionId);
  const isStandardUpdate = Number.isInteger(standardSizeSelectionId) && standardSizeSelectionId > 0;
  const payload = {
    userId: numericUserId,
    collarSize: toNullableNumber(standardSize.collarSize),
    sleeveLength: toNullableNumber(standardSize.sleeveLength),
    fit: standardSize.fit || null,
    standardSizeSelectionId: isStandardUpdate ? standardSizeSelectionId : 0
  };

  const url = isStandardUpdate
    ? `${API_BASE_URL}/UserManagement/UpdateStandardSize`
    : `${API_BASE_URL}/UserManagement/AddStandardSize`;

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    body: JSON.stringify(payload)
  });

  if (!res.ok) {
    alert('Failed to save standard size');
    return;
  }

  const saved = await res.json();

  setStandardSizeList(prev => {
    if (!prev || prev.length === 0) return [saved];
    const exists = prev.some(s => s.standardSizeSelectionId === saved.standardSizeSelectionId);
    return exists
      ? prev.map(s => (s.standardSizeSelectionId === saved.standardSizeSelectionId ? saved : s))
      : [...prev, saved];
  });

  // auto-select
  setSelectedSizeType('standard');
  setSelectedSizeId(saved.standardSizeSelectionId);
  setShowSizePanel(false);

  // reset form
  setStandardSizeSaved(null);
  setStandardSize({ collarSize: '', sleeveLength: '', fit: '' });

  alert('Standard size saved.');
};





// tiny preloader with progress callback
const preloadImages = (urls, onProgress) =>
  new Promise((resolve) => {
    if (!urls || urls.length === 0) return resolve();
    let loaded = 0, total = urls.length;
    urls.forEach((src) => {
      const img = new Image();
      const done = () => { loaded += 1; onProgress(Math.round((loaded / total) * 100)); if (loaded >= total) resolve(); };
      img.onload = done;
      img.onerror = done;
      img.src = src;
    });
  });

// Build the list of URLs that must be ready before we flip them on
const gatherPreviewUrls = (map, extras = []) => {
  const urls = [];
  if (map?.fabric) urls.push(map.fabric);
  ALLOWED_STYLES.forEach(k => { if (map?.[k]) urls.push(map[k]); });
  extras.forEach(u => { if (u) urls.push(u); });
  // dedupe
  return Array.from(new Set(urls));
};

const getRightPanelImageBatches = (data, selectedIdx) => {
  const fabrics = data?.fabrics || [];
  const selectedFabric = fabrics?.[selectedIdx];

  const fabricThumbs = fabrics
    .map((f) => f?.displayImage || f?.images?.[0]?.imageURL)
    .filter(Boolean);

  const styleThumbs = (selectedFabric?.styles || [])
    .map((s) => s?.imageURL)
    .filter(Boolean);

  return {
    fabricThumbs: Array.from(new Set(fabricThumbs)),
    styleThumbs: Array.from(new Set(styleThumbs))
  };
};


// Given an accent fabric and the chosen Collar styleID, return the specific accent image (if any)
const getAccentImageForCollar = (accentFabricId, collarStyleId) => {
  if (!accentFabrics || !collarStyleId) return null;
  const af = accentFabrics.find(f => f.fabricID === accentFabricId);
  if (!af) return null;
  const match = af.accentStyles?.find(s => s.styleOptionID === collarStyleId && s.imageURL);
  return match?.imageURL || null;
};

// Given the chosen Collar styleID, return this fabric's self-accent image (if any)
const getSelfAccentImageForCollar = (collarStyleId) => {
  const fabric = productData?.fabrics?.[selectedFabricIndex];
  if (!fabric || !collarStyleId) return null;
  const match = fabric.selfAccentCollars?.find(
    s => s.styleOptionID === collarStyleId && s.imageURL
  );
  return match?.imageURL || null;
};



const tabSequence = ['Fabric', 'Styles', 'Sizes', 'Summary'];

const goToNextTab = () => {
  const currentIndex = tabSequence.indexOf(activeTab);
  if (currentIndex < tabSequence.length - 1) {
    setActiveTab(tabSequence[currentIndex + 1]);
  }
};

const goToPrevTab = () => {
  const currentIndex = tabSequence.indexOf(activeTab);
  if (currentIndex > 0) {
    setActiveTab(tabSequence[currentIndex - 1]);
  }
};



useEffect(() => {
  if (user?.userId) {
    fetch(`${API_BASE_URL}/UserManagement/GetShirtMeasurements/${user.userId}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
      .then(res => res.json())
      .then(data => setShirtMeasurements(Array.isArray(data) ? data : []))
      .catch(err => console.error("Error loading shirt measurements:", err));
  }
}, [user]);

const handleSaveShirtMeasurement = async () => {
  if (!user?.userId) {
    const guestShirtId = selectedShirtMeasurement?.shirtMeasurementId || `guest_shirt_${Date.now()}`;
    setShirtMeasurements([{ shirtMeasurementId: guestShirtId, ...shirtForm }]);
    saveGuestSize({
      sizeType: 'shirt',
      sizeId: guestShirtId,
      shirt: { ...shirtForm }
    });
    setSelectedSizeType('shirt');
    setSelectedSizeId(guestShirtId);
    setShowShirtPopup(false);
    setShowSizePanel(false);
    return;
  }

  const shirtMeasurementId = Number(selectedShirtMeasurement?.shirtMeasurementId);
  const isShirtUpdate = Number.isInteger(shirtMeasurementId) && shirtMeasurementId > 0;
  const payload = {
    userId: user.userId,
    shirtMeasurementId: isShirtUpdate ? shirtMeasurementId : 0,
    collarAround: toNullableNumber(shirtForm.collarAround),
    sleeveLength: toNullableNumber(shirtForm.sleeveLength),
    yokeWidth: toNullableNumber(shirtForm.yokeWidth),
    chestWidth: toNullableNumber(shirtForm.chestWidth),
    midsectionWidth: toNullableNumber(shirtForm.midsectionWidth),
    shirtLength: toNullableNumber(shirtForm.shirtLength),
    sleeveWidth: toNullableNumber(shirtForm.sleeveWidth),
    cuffAround: toNullableNumber(shirtForm.cuffAround)
  };

  const url = isShirtUpdate
    ? `${API_BASE_URL}/UserManagement/UpdateShirtMeasurement`
    : `${API_BASE_URL}/UserManagement/AddShirtMeasurement`;

  const res = await fetch(url, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  },
  body: JSON.stringify(payload)
});

  if (res.ok) {
    const saved = await res.json();
    const updated = selectedShirtMeasurement
      ? shirtMeasurements.map(m => m.shirtMeasurementId === saved.shirtMeasurementId ? saved : m)
      : [...shirtMeasurements, saved];

    setShirtMeasurements(updated);
    setShowShirtPopup(false);
    setSelectedShirtMeasurement(null);
    setShirtForm({
      collarAround: '',
      sleeveLength: '',
      yokeWidth: '',
      chestWidth: '',
      midsectionWidth: '',
      shirtLength: '',
      sleeveWidth: '',
      cuffAround: ''
    });
  } else {
    alert('Failed to save measurement');
  }
};

const handleDeleteShirtMeasurement = async (id) => {
  if (!window.confirm("Are you sure you want to delete this measurement?")) return;

  const res = await fetch(`${API_BASE_URL}/UserManagement/DeleteShirtMeasurement/${id}`, {
  method: 'POST',
  headers: token ? { Authorization: `Bearer ${token}` } : {}
});


  if (res.ok) {
    setShirtMeasurements(prev => prev.filter(m => m.shirtMeasurementId !== id));
  } else {
    alert('Failed to delete measurement');
  }
};


useEffect(() => {
  if (user?.userId) {
    fetch(`${API_BASE_URL}/UserManagement/GetBodyMeasurements/${user.userId}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
      .then(res => res.json())
      .then(data => setBodyMeasurements(Array.isArray(data) ? data : []))
      .catch(() => setBodyMeasurements([]));
  }
}, [user]);

const handleSaveBodyMeasurement = async (e) => {
  e.preventDefault();
  const form = e.target;
  const formData = new FormData(form);

  if (!user?.userId) {
    const guestBodyId = editingBodyMeasurement?.bodyMeasurementId || `guest_body_${Date.now()}`;
    const guestBody = {
      bodyMeasurementId: guestBodyId,
      neckAround: formData.get('neckAround') || '',
      sleeveLength: formData.get('sleeveLength') || '',
      shoulderWidth: formData.get('shoulderWidth') || '',
      chestAround: formData.get('chestAround') || '',
      waistAround: formData.get('waistAround') || '',
      shirtLength: formData.get('shirtLength') || '',
      bicepAround: formData.get('bicepAround') || '',
      wristAround: formData.get('wristAround') || '',
      fit: formData.get('fit') || 'Regular'
    };

    setBodyMeasurements([guestBody]);
    saveGuestSize({
      sizeType: 'body',
      sizeId: guestBodyId,
      body: guestBody
    });

    setSelectedSizeType('body');
    setSelectedSizeId(guestBodyId);
    setShowMeasurePopup(false);
    setShowSizePanel(false);
    return;
  }

  const bodyMeasurementId = Number(editingBodyMeasurement?.bodyMeasurementId);
  const isBodyUpdate = Number.isInteger(bodyMeasurementId) && bodyMeasurementId > 0;
  const payload = {
    userId: user.userId,
    bodyMeasurementId: isBodyUpdate ? bodyMeasurementId : 0,
    neckAround: toNullableNumber(formData.get('neckAround')),
    sleeveLength: toNullableNumber(formData.get('sleeveLength')),
    shoulderWidth: toNullableNumber(formData.get('shoulderWidth')),
    chestAround: toNullableNumber(formData.get('chestAround')),
    waistAround: toNullableNumber(formData.get('waistAround')),
    shirtLength: toNullableNumber(formData.get('shirtLength')),
    bicepAround: toNullableNumber(formData.get('bicepAround')),
    wristAround: toNullableNumber(formData.get('wristAround')),
    fit: formData.get('fit')
  };

  const apiUrl = isBodyUpdate ? 'UpdateBodyMeasurement' : 'AddBodyMeasurement';

  const res = await fetch(`${API_BASE_URL}/UserManagement/${apiUrl}`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  },
  body: JSON.stringify(payload)
});


  if (res.ok) {
    const updatedList = await fetch(`${API_BASE_URL}/UserManagement/GetBodyMeasurements/${user.userId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    }).then(r => r.json());
    setBodyMeasurements(updatedList);
    setShowMeasurePopup(false);
    setEditingBodyMeasurement(null);
  } else {
    alert("Failed to save measurement.");
  }
};

const handleDeleteBodyMeasurement = async (id) => {
  if (!window.confirm("Are you sure you want to delete this measurement?")) return;

  const res = await fetch(`${API_BASE_URL}/UserManagement/DeleteBodyMeasurement/${id}`, {
  method: 'POST',
  headers: token ? { Authorization: `Bearer ${token}` } : {}
});

  if (res.ok) {
    setBodyMeasurements(prev => prev.filter(b => b.bodyMeasurementId !== id));
    setSelectedBodyMeasurementId(null);
  } else {
    alert("Failed to delete measurement.");
  }
};



const [smartSizes, setSmartSizes] = useState([]);

const handleEditSmartSize = (smartSize) => {
      sessionStorage.setItem(SESSION_RETURN_KEY, location.pathname + location.search + location.hash);
      localStorage.setItem('editSmartSize', JSON.stringify(smartSize));
      navigate(`/smartSizes/edit/${user?.userId || 0}`);
    };

useEffect(() => {
  const checkUser = () => setUser(JSON.parse(localStorage.getItem('user')));
  window.addEventListener('storage', checkUser);
  return () => window.removeEventListener('storage', checkUser);
}, []);

useEffect(() => {
  if (user?.userId) {
    fetch(`${API_BASE_URL}/UserManagement/GetSmartSizes/${user.userId}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  })
      .then(res => res.json())
      .then(data => setSmartSizes(Array.isArray(data) ? data : []))
      .catch(err => {
        console.error("Error fetching smart sizes in Customize:", err);
        setSmartSizes([]);
      });
  }
}, [user]);



useEffect(() => {
    const closeDropdowns = (e) => {
      if (!e.target.closest(".measure-custom-select")) {
        setFitDropdownOpen(false);
      }
      if (!e.target.closest(".measureShirt-custom-select")) {
        setShirtDropdownOpen(false);
      }
    };
    document.addEventListener("click", closeDropdowns);
    return () => document.removeEventListener("click", closeDropdowns);
  }, []);

  useEffect(() => {
    if (activeTab !== 'Styles' || !productData) return;
  
    const headers = document.querySelectorAll('.collapsible-header');
    const contents = document.querySelectorAll('.collapsible-content');
  
    const handleClick = (e) => {
      const header = e.currentTarget;
      const targetId = header.getAttribute('data-target');
      const targetEl = document.getElementById(targetId);
  
      // Remove active and hide all
      headers.forEach(h => h.classList.remove('active'));
      contents.forEach(c => {
        c.style.display = 'none';
        c.style.gridTemplateColumns = '';
        c.style.gap = '';
      });
  
      // Activate clicked header and show its content
      header.classList.add('active');
      if (targetEl) {
        targetEl.style.display = 'grid';
        // targetEl.style.gridTemplateColumns = 'repeat(auto-fit, minmax(300px, 1fr))';
        targetEl.style.gap = '20px';
      }
    };
  
    headers.forEach(header => {
      header.addEventListener('click', handleClick);
    });
  
    // Default to the first one
    if (headers.length > 0) {
      headers[0].classList.add('active');
      const firstTarget = headers[0].getAttribute('data-target');
      const firstContent = document.getElementById(firstTarget);
      if (firstContent) {
        firstContent.style.display = 'grid';
        // firstContent.style.gridTemplateColumns = 'repeat(auto-fit, minmax(300px, 1fr))';
        firstContent.style.gap = '20px';
      }
    }
  
    // Cleanup
    return () => {
      headers.forEach(header => header.removeEventListener('click', handleClick));
    };
  }, [productData, activeTab, showAdvancedStyleMenus]);
  

  
  useEffect(() => {
    const sleeveTabs = Array.from(document.querySelectorAll(".sleeve-tab"));
    const cuffOptions = Array.from(document.querySelectorAll(".cuff-option"));

    const handler = (tab) => () => {
      sleeveTabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");
      const selectedSleeve = tab.getAttribute("data-sleeve");
      cuffOptions.forEach(option => {
        option.style.display = option.getAttribute("data-sleeve") === selectedSleeve ? "grid" : "none";
      });
    };

    sleeveTabs.forEach(tab => tab.addEventListener("click", handler(tab)));

    document.querySelector('.sleeve-tab[data-sleeve="long"]')?.click();

    return () => sleeveTabs.forEach(tab => tab.removeEventListener("click", handler(tab)));
  }, [productData]);


  
  useEffect(() => {
    const select = document.querySelector('.custom-style-select');
    if (!select) return;
  
    const trigger = select.querySelector('.custom-select-trigger');
    const options = select.querySelectorAll('.custom-option');
  
    const toggleDropdown = () => {
      select.classList.toggle('open');
    };
  
    const handleOptionClick = (option) => {
      if (!option.classList.contains('selected')) {
        trigger.textContent = option.textContent;
        select.classList.remove('open');
      }
    };
  
    trigger?.addEventListener('click', toggleDropdown);
    options.forEach(option => option.addEventListener('click', () => handleOptionClick(option)));
  
    const handleOutsideClick = (e) => {
      if (!select.contains(e.target)) {
        select.classList.remove('open');
      }
    };
  
    document.addEventListener('click', handleOutsideClick);
  
    return () => {
      trigger?.removeEventListener('click', toggleDropdown);
      options.forEach(option => option.removeEventListener('click', handleOptionClick));
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [selectedProfile]);
  
  
  useEffect(() => {
  const selectedFabric = productData?.fabrics?.[selectedFabricIndex];
  if (!selectedFabric) {
    setProductPrice(0);
    return;
  }

  const basePrice = selectedFabric.basePrice || 0;

  const selectedStyleIDsArray = Object.values(selectedStyleIDs).filter(Boolean);
  const selectedStyles = selectedStyleIDsArray.map((styleID) =>
    selectedFabric.styles.find((style) => style.styleID === styleID)
  );

  const stylesPriceImpact = selectedStyles.reduce((total, style) => {
    return total + (style?.priceImpact || 0);
  }, 0);

  const monogramCost = isMonogramEnabled ? 10 : 0;
  const collarAccentCost = isCollarAccentEnabled ? 5 : 0;
  const cuffAccentCost = isCuffAccentEnabled ? 5 : 0;

  const totalPrice = basePrice + stylesPriceImpact + monogramCost + collarAccentCost + cuffAccentCost;
  setProductPrice(totalPrice);
}, [
  selectedFabricIndex,
  selectedStyleIDs,
  productData,
  isMonogramEnabled,
  isCollarAccentEnabled,
  isCuffAccentEnabled
]);



const calculateEstimatedDelivery = (minDays, maxDays) => {
  const today = new Date();

  const minDate = new Date(today);
  minDate.setDate(today.getDate() + minDays);

  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + maxDays);

  const formatDate = (date) =>
    date.toLocaleString('en-US', { month: 'short', day: 'numeric' });

  if (minDays === maxDays) {
    return `${formatDate(maxDate)}`;
  } else {
    return `${formatDate(minDate)} – ${formatDate(maxDate)}`;
  }
};

const getDeliveryWindow = (productPayload) => {
  const c = productPayload?.category || productPayload?.Category || null;
  if (!c) return { minDays: null, maxDays: null };

  const buckets = [
    c,
    c?.parentCategory,
    c?.ParentCategory,
    c?.topCategory,
    c?.TopCategory
  ].filter(Boolean);

  for (const b of buckets) {
    const minRaw = b?.minDeliveryDays ?? b?.MinDeliveryDays;
    const maxRaw = b?.maxDeliveryDays ?? b?.MaxDeliveryDays;
    const minDays = Number(minRaw);
    const maxDays = Number(maxRaw);
    if (Number.isFinite(minDays) && Number.isFinite(maxDays) && minDays > 0 && maxDays > 0) {
      return { minDays, maxDays };
    }
  }

  return { minDays: null, maxDays: null };
};

  useEffect(() => {
  const fetchData = async () => {
    try {
      // ✅ read fabricId from querystring
      const params = new URLSearchParams(location.search);
      const requestedFabricId = params.get('fabricId')
        ? parseInt(params.get('fabricId'), 10)
        : null;

      if (id) {
        setIsRightFabricReady(false);
        setIsRightStylesReady(false);
        setShouldStageRightLoad(true);
        // ✅ Product-specific mode
        const res = await fetch(`${API_BASE_URL}/api/insideproducts/${id}`);
        const data = await res.json();

        // ✅ FILTER: keep only customizable fabrics
        const filteredFabrics = (Array.isArray(data.fabrics) ? data.fabrics : [])
          .filter(f => f?.isCustomizable === true);

        // ✅ update productData with filtered fabrics
        const filteredData = { ...data, fabrics: filteredFabrics };
        setProductData(filteredData);

        // ✅ pick fabric index (default 0, or match by fabricID) from FILTERED list
        let initialIndex = 0;
        if (requestedFabricId && Array.isArray(filteredFabrics)) {
          const idx = filteredFabrics.findIndex((f) => f.fabricID === requestedFabricId);
          if (idx >= 0) initialIndex = idx;
        }

        setSelectedFabricIndex(initialIndex);
        setAccentFabrics(filteredFabrics?.[initialIndex]?.accentFabrics || []);

        const fabric = filteredFabrics?.[initialIndex];

        const previewMap = {};

        previewMap.fabric =
          fabric?.baseLayerImage?.includes(`/fabric_base/`) && fabric?.baseLayerImage
            ? fabric.baseLayerImage
            : '/assets/images/customProduct/_image.png';

        const styleIDs = {};
        ALLOWED_STYLES.forEach((styleTypeKey) => {
          const style = fabric?.styles?.find(
            (s) => s.styleType.toLowerCase().replace(/[\s/]/g, '') === styleTypeKey
          );
          if (style) {
            const preview = fabric?.previewImages?.find(
              (p) =>
                p.styleType.toLowerCase().replace(/[\s/]/g, '') === styleTypeKey &&
                p.styleName === style.styleName
            );
            previewMap[styleTypeKey] = preview?.imageURL || style.imageURL;
            styleIDs[styleTypeKey] = style.styleID;

            if (styleTypeKey === 'collar') {
              setSelectedCollarName(style.styleName);
            }
          }
        });

        setPendingOptions(previewMap);
        setSelectedStyleIDs(styleIDs);
        setSelectedProfile('No Style Profile Selected');

        const { minDays, maxDays } = getDeliveryWindow(data);
        if (minDays !== null && maxDays !== null) {
          setDeliveryEstimate(calculateEstimatedDelivery(minDays, maxDays));
        } else {
          setDeliveryEstimate('');
        }
      } else {
        setIsRightFabricReady(false);
        setIsRightStylesReady(false);
        setShouldStageRightLoad(true);
        // ✅ Create-a-Shirt mode → fetch all fabrics
        const res = await fetch(`${API_BASE_URL}/api/insidefabrics`);
        const resp = await res.json();

        // ✅ FILTER: keep only customizable fabrics
        const fabrics = (Array.isArray(resp) ? resp : resp?.fabrics || [])
          .filter(f => f?.isCustomizable === true);

        // ✅ pick fabric index (default 0, or match by fabricID) from FILTERED list
        let initialIndex = 0;
        if (requestedFabricId && Array.isArray(fabrics)) {
          const idx = fabrics.findIndex((f) => f.fabricID === requestedFabricId);
          if (idx >= 0) initialIndex = idx;
        }

        // mimic same structure as productData
        const fakeProduct = {
          productID: 0,
          productName: 'Create a Shirt',
          description: 'Design your custom shirt from all available fabrics.',
          discountPrice: null,
          discountPercentage: null,
          tags: [],
          category: null,
          fabrics: fabrics,
          firstFabricImage:
            fabrics?.[initialIndex]?.images?.[0]?.imageURL || '/assets/images/default-fabric.jpg',
          firstFabricDefaultPrice: fabrics?.[initialIndex]?.defaultTotalPrice || 0,
          createdAt: null,
          updatedAt: null,
        };


        setProductData(fakeProduct);

        setSelectedFabricIndex(initialIndex);
        setAccentFabrics(fabrics?.[initialIndex]?.accentFabrics || []);

        const fabric = fabrics?.[initialIndex];
        const previewMap = {};

        previewMap.fabric =
          fabric?.baseLayerImage?.includes(`/fabric_base/`) && fabric?.baseLayerImage
            ? fabric.baseLayerImage
            : '/assets/images/customProduct/_image.png';

        const styleIDs = {};
        ALLOWED_STYLES.forEach((styleTypeKey) => {
          const style = fabric?.styles?.find(
            (s) => s.styleType.toLowerCase().replace(/[\s/]/g, '') === styleTypeKey
          );
          if (style) {
            const preview = fabric?.previewImages?.find(
              (p) =>
                p.styleType.toLowerCase().replace(/[\s/]/g, '') === styleTypeKey &&
                p.styleName === style.styleName
            );
            previewMap[styleTypeKey] = preview?.imageURL || style.imageURL;
            styleIDs[styleTypeKey] = style.styleID;

            if (styleTypeKey === 'collar') {
              setSelectedCollarName(style.styleName);
            }
          }
        });

        setPendingOptions(previewMap);
        setSelectedStyleIDs(styleIDs);
        setSelectedProfile('No Style Profile Selected');
      }
    } catch (err) {
      console.error('Failed to load customization data', err);
    }
  };

  fetchData();
}, [id, location.search]);





  useEffect(() => {
    const leftSection = leftSectionRef.current;
    const rightSection = rightSectionRef.current;
  
    if (!leftSection || !rightSection) return;
  
    const handleScroll = () => {
      const rightHeight = rightSection.scrollHeight;
      const scrollPos = rightSection.scrollTop + rightSection.clientHeight;
  
      if (scrollPos >= rightHeight) {
        leftSection.style.position = 'relative';
      } else {
        leftSection.style.position = 'sticky';
      }
    };
  
    rightSection.addEventListener('scroll', handleScroll);
    return () => rightSection.removeEventListener('scroll', handleScroll);
  }, []);
  

  useEffect(() => {
    const tabs = document.querySelectorAll('.custom-tab-btn');
    const tabContents = document.querySelectorAll('.custom-tab-content');
  
    tabContents.forEach((content) => {
      content.classList.remove('active');
      content.style.transform = 'translateX(100%)';
      content.style.opacity = '0';
    });
  
    const activeContent = document.querySelector(`#${activeTab.toLowerCase()}-tab`);
    if (activeContent) {
      activeContent.classList.add('active');
      setTimeout(() => {
        activeContent.style.transform = 'translateX(0)';
        activeContent.style.opacity = '1';
      }, 50);
    }
  
  }, [activeTab]);

  useEffect(() => {
    document.body.classList.toggle('no-scroll', isPopupOpen);
  }, [isPopupOpen]);
  
  useEffect(() => {
    if (slidesRef.current) {
      slidesRef.current.style.transform = `translateX(-${currentSlideIndex * 100}%)`;
    }
  }, [currentSlideIndex]);

  // Normalize preview styleType to our keys
const toSimpleKey = (raw) => {
  const norm = (raw || '').toLowerCase().replace(/[\s/]/g, '');
  if (norm === 'frontplacket') return 'front';
  return norm; // collar, cuff, pocket, etc.
};



  // Compute button overlays for Collar, Cuff, and Front(=Placket) whenever selections change
  useEffect(() => {
    const fabric = productData?.fabrics?.[selectedFabricIndex];
    if (!fabric) {
      setButtonOverlayImages({});
      return;
    }

    // Need a chosen Buttons style AND a chosen dependent style for each target
    const selectedButtonsId = selectedStyleIDs['buttons'];
    if (!selectedButtonsId) {
      setButtonOverlayImages({});
      return;
    }

    // Normalize preview styleType ("Front/Placket" -> "front")
    // const toSimpleKey = (raw) => {
    //   const norm = (raw || '').toLowerCase().replace(/[\s/]/g, ''); // remove spaces + '/'
    //   if (norm === 'frontplacket') return 'front'; // map API "Front/Placket" bucket to our "front" key
    //   return norm; // "collar", "cuff" already match our keys
    // };

    // const targets = ['collar', 'cuff', 'front'];
    const targets = ['collar', 'cuff', 'front', 'pocket'];
    const overlays = {};

    // Walk every preview image; if it has buttonOverlays that match our Buttons + dependent style, pick its image
    (fabric.previewImages || []).forEach((p) => {
      const simple = toSimpleKey(p.styleType);
      if (!targets.includes(simple)) return;

      const dependentId = selectedStyleIDs[simple];
      if (!dependentId) return;

      const matches = (p.buttonOverlays || []).find(
        (bo) =>
          bo?.buttonStyleOptionID === selectedButtonsId &&
          bo?.dependentStyleOptionID === dependentId &&
          bo?.imageURL
      );

      if (matches?.imageURL) {
        overlays[simple] = matches.imageURL; // first match wins
      }
    });

    setButtonOverlayImages(overlays);
  }, [productData, selectedFabricIndex, selectedStyleIDs]);

  useEffect(() => {
  const fabric = productData?.fabrics?.[selectedFabricIndex];
  if (!fabric) {
    setButtonHoleOverlayImages({});
    return;
  }
  // Use the selected Button Holes style, not Buttons
  const selectedButtonHolesId = selectedStyleIDs['buttonholes'];
  if (!selectedButtonHolesId) {
    setButtonHoleOverlayImages({});
    return;
  }
  const targets = ['collar', 'cuff', 'front', 'pocket'];
  const holeOverlays = {};
  (fabric.previewImages || []).forEach((p) => {
    const simple = toSimpleKey(p.styleType);
    if (!targets.includes(simple)) return;
    const dependentId = selectedStyleIDs[simple];
    if (!dependentId) return;

    // API may expose hole style id as holeStyleOptionID. Fallback to buttonStyleOptionID for backward compat.
    const match = (p.buttonHoleOverlays || []).find(
      (bo) =>
        ((bo?.holeStyleOptionID ?? bo?.buttonStyleOptionID) === selectedButtonHolesId) &&
        bo?.dependentStyleOptionID === dependentId &&
        bo?.imageURL
    );
    if (match?.imageURL) holeOverlays[simple] = match.imageURL;
  });
  setButtonHoleOverlayImages(holeOverlays);
}, [productData, selectedFabricIndex, selectedStyleIDs]);



  // Pick which collar accent image to show:
  // - If collar accent is enabled AND a fabric is selected -> use that accent image
  // - Otherwise -> use the fabric's default self accent image (for the selected collar)
  useEffect(() => {
    const collarId = selectedStyleIDs['collar'];
    if (!collarId) {
      setCollarAccentImage(null);
      return;
    }

    // External accent takes precedence if enabled and a fabric is chosen
    if (isCollarAccentEnabled && selectedAccentFabricId) {
      const url = getAccentImageForCollar(selectedAccentFabricId, collarId);
      setCollarAccentImage(url || null);
      return;
    }

    // Fallback to self accent by default
    const selfUrl = getSelfAccentImageForCollar(collarId);
    setCollarAccentImage(selfUrl || null);
  }, [
    selectedStyleIDs,
    selectedFabricIndex,
    isCollarAccentEnabled,
    selectedAccentFabricId,
    productData
  ]);
  
  // When pendingOptions changes, preload everything, show progress bar + blur, then commit to selectedOptions
  useEffect(() => {
    if (!pendingOptions) return;

    // Extras that also appear as layers: collar accent + button overlays
    const extras = [];
    if (collarAccentImage) extras.push(collarAccentImage);
    Object.values(buttonOverlayImages || {}).forEach(u => { if (u) extras.push(u); });
    Object.values(buttonHoleOverlayImages || {}).forEach(u => { if (u) extras.push(u); });

    const allLeftUrls = gatherPreviewUrls(pendingOptions, extras);
    const fabricLayerUrl = pendingOptions?.fabric ? [pendingOptions.fabric] : [];
    const styleLayerUrls = allLeftUrls.filter((u) => u && u !== pendingOptions?.fabric);

    setIsPreviewLoading(true);
    setLoadProgress(0);

    preloadImages(fabricLayerUrl, setLoadProgress)
      .then(() => preloadImages(styleLayerUrls, setLoadProgress))
      .then(() => {
        // commit left preview first
        setSelectedOptions(pendingOptions);
        setPendingOptions(null);
        setIsPreviewLoading(false);
        setLoadProgress(100);
      })
      .then(() => {
        if (!shouldStageRightLoad) return;
        const { fabricThumbs, styleThumbs } = getRightPanelImageBatches(productData, selectedFabricIndex);
        return preloadImages(fabricThumbs, () => {})
          .then(() => {
            setIsRightFabricReady(true);
            return preloadImages(styleThumbs, () => {});
          })
          .then(() => {
            setIsRightStylesReady(true);
            setShouldStageRightLoad(false);
          });
      })
      .catch(() => {
        setIsPreviewLoading(false);
        setIsRightFabricReady(true);
        setIsRightStylesReady(true);
        setShouldStageRightLoad(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingOptions, productData, selectedFabricIndex, shouldStageRightLoad]);

  // If overlays/accent change on top of current map, briefly show loader while they warm
  useEffect(() => {
    const extras = [];
    if (collarAccentImage) extras.push(collarAccentImage);
    Object.values(buttonOverlayImages || {}).forEach(u => { if (u) extras.push(u); });
    Object.values(buttonHoleOverlayImages || {}).forEach(u => { if (u) extras.push(u); });

    if (extras.length === 0) return;
    setIsPreviewLoading(true);
    setLoadProgress(0);
    preloadImages(extras, setLoadProgress).then(() => {
      setIsPreviewLoading(false);
      setLoadProgress(100);
    });
  }, [collarAccentImage, buttonOverlayImages, isCollarAccentEnabled, isCuffAccentEnabled]);


  

const handleFabricSelect = (fabric, index) => {
  // Build defaults per style TYPE using this fabric’s styles
  const defaultOptions = {};
  const defaultStyleIDs = {};

  // Base fabric image
  defaultOptions.fabric =
    fabric?.baseLayerImage?.includes(`/fabric_base/`) && fabric?.baseLayerImage
      ? fabric.baseLayerImage
      : '/assets/images/customProduct/_image.png';

  // For each allowed style type, pick this fabric's default style
  ALLOWED_STYLES.forEach((styleTypeKey) => {
    // pick first style of this type in this fabric
    const style = fabric.styles?.find(
      (s) => s.styleType.toLowerCase().replace(/[\s/]/g, '') === styleTypeKey
    );
    if (!style) return;

    // find matching preview image by type + style name
    const preview = fabric.previewImages?.find(
      (p) =>
        p.styleType.toLowerCase().replace(/[\s/]/g, '') === styleTypeKey &&
        p.styleName === style.styleName
    );

    defaultOptions[styleTypeKey] = preview?.imageURL || style.imageURL || '';
    defaultStyleIDs[styleTypeKey] = style.styleID;

    // remember collar name for accent availability text
    if (styleTypeKey === 'collar') {
      setSelectedCollarName(style.styleName);
    }
  });

  // Commit new fabric selection
  setIsRightFabricReady(false);
  setIsRightStylesReady(false);
  setShouldStageRightLoad(true);
  setSelectedFabricIndex(index);
  setSelectedProfile('No Style Profile Selected');

  // Reset overlays and accents
  setButtonOverlayImages({});
  setButtonHoleOverlayImages({});
  setAccentFabrics(fabric.accentFabrics || []);
  setSelectedAccentFabricId(null);
  setCollarAccentImage(null);

  // Reset monogram UI
  setIsMonogramEnabled(false);
  setMonogramInitials('');
  setMonogramStyle('Block');
  setMonogramColor('Black');
  setMonogramPlacement('Left Center Cuff');
  setActiveStyleType(null);

  // Trigger preload + swap
  setPendingOptions(defaultOptions);
  setSelectedStyleIDs(defaultStyleIDs);
};

const getSelectedStyleSnapshot = () => {
  const selectedFabric = productData?.fabrics?.[selectedFabricIndex];
  if (!selectedFabric) return { ids: [], names: [] };

  const selectedPairs = Object.entries(selectedStyleIDs || {})
    .map(([_, styleId]) => {
      const id = Number(styleId);
      if (!id) return null;
      const style = (selectedFabric.styles || []).find((s) => s.styleID === id);
      return style ? { id: style.styleID, name: style.styleName } : null;
    })
    .filter(Boolean);

  return {
    ids: selectedPairs.map((x) => x.id),
    names: selectedPairs.map((x) => x.name)
  };
};



  if (!productData) return <div>Loading customization options...</div>;

  const stylesByType = {};
  productData.fabrics?.[selectedFabricIndex]?.styles?.forEach((style) => {
    const key = style.styleType;
    const lowerKey = key.toLowerCase().replace(/[\s/]/g, '');
    if (ALLOWED_STYLES.includes(lowerKey)) {
      if (!stylesByType[key]) stylesByType[key] = [];
      stylesByType[key].push(style);
    }
  });

  const orderedStyleEntries = [
    ...STYLE_DISPLAY_ORDER
      .map((k) => Object.entries(stylesByType).find(([styleType]) => styleType.toLowerCase().replace(/[\s/]/g, '') === k))
      .filter(Boolean),
    ...Object.entries(stylesByType).filter(([styleType]) => {
      const k = styleType.toLowerCase().replace(/[\s/]/g, '');
      return !STYLE_DISPLAY_ORDER.includes(k) && !POST_ACCENT_STYLE_ORDER.includes(k);
    })
  ];

  const postAccentStyleEntries = [
    ...POST_ACCENT_STYLE_ORDER
      .map((k) => Object.entries(stylesByType).find(([styleType]) => styleType.toLowerCase().replace(/[\s/]/g, '') === k))
      .filter(Boolean)
  ];

  const handleAddToCart = async () => {
  const selectedFabric = productData?.fabrics?.[selectedFabricIndex];
  if (!selectedFabric) {
    alert("No fabric selected.");
    return;
  }

  const { ids: styleOptionIds, names: styleOptionNames } = getSelectedStyleSnapshot();
  if (styleOptionIds.length === 0) {
    alert("Please select at least one style option.");
    return;
  }

  if (!selectedSizeType) {
    alert("Please select a size before adding to bag.");
    return;
  }

  if (!user || !user.userId) {
    addGuestCartItem({
      productId: productData.productID,
      fabricId: selectedFabric.fabricID,
      productName: productData.productName,
      fabricName: selectedFabric.fabricName,
      fabricColour: selectedFabric.fabricColour,
      fabricImageUrl: selectedFabric.images?.[0]?.imageURL || selectedFabric.displayImage,
      styleOptionIds,
      styleOptionNames,
      price: productPrice || 0,
      sizeType: selectedSizeType,
      sizeId: selectedSizeId,
      sizeSnapshot: safeParse(sessionStorage.getItem('ccc_guest_size'), null),
      createdAt: Date.now()
    });

    navigate('/cart');
    return;
  }

  const payload = {
    userId: user.userId,
    productId: productData.productID,
    fabricId: selectedFabric.fabricID,
    styleOptionIds: styleOptionIds,
    price: productPrice || 0,

    // ✅ Correct size mapping:
    standardSizeSelectionId: selectedSizeType === 'standard' ? selectedSizeId : null,
    smartSizeId: selectedSizeType === 'smart' ? selectedSizeId : null,
    bodyMeasurementId: selectedSizeType === 'body' ? selectedSizeId : null,
    shirtMeasurementId: selectedSizeType === 'shirt' ? selectedSizeId : null,
    isMailUsSelected: selectedSizeType === 'mail',

    // ✅ Monogram fields:
    isMonogram: isMonogramEnabled,
    monogramInitials: monogramInitials || null,
    monogramStyle: monogramStyle || null,
    monogramColor: monogramColor || null,
    monogramPlacement: monogramPlacement || null,

    isCollarAccentEnabled,
    isCuffAccentEnabled,
    accentFabricId: selectedAccentFabricId
  };

  try {
    const res = await fetch(`${API_BASE_URL}/UserManagement/AddToCart`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  },
  body: JSON.stringify(payload)
});

    const data = await res.json();

    if (!res.ok) {
      alert(data.message || 'Failed to add item to cart.');
      return;
    }

    alert("Item added to bag!");

  } catch (error) {
    console.error("Add to cart failed:", error);
    alert("Something went wrong while adding to cart.");
  }
};

const handleAddToWishlist = async () => {
  const selectedFabric = productData?.fabrics?.[selectedFabricIndex];
  if (!selectedFabric) {
    alert("No fabric selected.");
    return;
  }

  const { ids: styleOptionIds } = getSelectedStyleSnapshot();
  if (styleOptionIds.length === 0) {
    alert("Please select at least one style option.");
    return;
  }

  if (!selectedSizeType) {
    alert("Please select a size before adding to wishlist.");
    return;
  }

  if (!user || !user.userId) {
    const { names: styleOptionNames } = getSelectedStyleSnapshot();
    addGuestWishlistItem({
      productId: productData.productID,
      fabricId: selectedFabric.fabricID,
      productName: productData.productName,
      fabricName: selectedFabric.fabricName,
      fabricColour: selectedFabric.fabricColour,
      fabricImageUrl: selectedFabric.images?.[0]?.imageURL || selectedFabric.displayImage,
      styleOptionIds,
      styleOptionNames,
      price: productPrice || 0,
      sizeType: selectedSizeType,
      sizeId: selectedSizeId,
      sizeSnapshot: safeParse(sessionStorage.getItem('ccc_guest_size'), null),
      createdAt: Date.now()
    });
    alert("Item added to wishlist!");
    return;
  }

  const payload = {
    userId: user.userId,
    productId: productData.productID,
    fabricId: selectedFabric.fabricID,
    styleOptionIds: styleOptionIds,
    price: productPrice || 0,

    // ✅ Correct size mapping:
    standardSizeSelectionId: selectedSizeType === 'standard' ? selectedSizeId : null,
    smartSizeId: selectedSizeType === 'smart' ? selectedSizeId : null,
    bodyMeasurementId: selectedSizeType === 'body' ? selectedSizeId : null,
    shirtMeasurementId: selectedSizeType === 'shirt' ? selectedSizeId : null,
    isMailUsSelected: selectedSizeType === 'mail',

    // ✅ Monogram fields:
    isMonogram: isMonogramEnabled,
    monogramInitials: monogramInitials || null,
    monogramStyle: monogramStyle || null,
    monogramColor: monogramColor || null,
    monogramPlacement: monogramPlacement || null,

    isCollarAccentEnabled,
    isCuffAccentEnabled,
    accentFabricId: selectedAccentFabricId
  };

  try {
    const res = await fetch(`${API_BASE_URL}/UserManagement/AddToWishlist`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  },
  body: JSON.stringify(payload)
});

    const data = await res.json();

    if (!res.ok) {
      alert(data.message || 'Failed to add item to wishlist.');
      return;
    }

    alert("Item added to wishlist!");

  } catch (error) {
    console.error("Add to wishlist failed:", error);
    alert("Something went wrong while adding to wishlist.");
  }
};








  const handleSleeveTabClick = (styleTypeKey, sleeve) => {
    setSelectedSleeveGroup(prev => ({
      ...prev,
      [styleTypeKey]: sleeve
    }));

    const tabs = document.querySelectorAll(`[data-styletype="${styleTypeKey}"]`);
    tabs.forEach(t => {
      t.classList.remove('active');
      if (t.getAttribute('data-sleeve') === sleeve) {
        t.classList.add('active');
      }
    });
  };

  const colorMap = {
    'Black': '#000000',
    'White': '#FFFFFF',
    'Gray': '#808080',
    'Lt Gray': '#D3D3D3',
    'Red': '#FF0000',
    'Burgundy': '#800020',
    'Brown': '#8B4513',
    'Gold': '#FFD700',
    'Yellow': '#FFFF00',
    'Green': '#008000',
    'Navy': '#000080',
    'Royal Blue': '#4169E1',
    'Lt Blue': '#ADD8E6',
    'Pink': '#FFC0CB',
    'Lilac': '#C8A2C8'
  };

  const getColorHex = (colorName) => {
  const colors = {
    'Black': '#000000',
    'White': '#FFFFFF',
    'Gray': '#808080',
    'Lt Gray': '#D3D3D3',
    'Red': '#FF0000',
    'Burgundy': '#800020',
    'Brown': '#8B4513',
    'Gold': '#FFD700',
    'Yellow': '#FFFF00',
    'Green': '#008000',
    'Navy': '#000080',
    'Royal Blue': '#4169E1',
    'Lt Blue': '#ADD8E6',
    'Pink': '#FFC0CB',
    'Lilac': '#C8A2C8'
  };
  return colors[colorName] || '#000000';
};

const handleStyleProfileSelect = (profile) => {
  const selectedFabric = productData.fabrics[selectedFabricIndex];
  if (!selectedFabric) return;

  const updatedOptions = {};
  const updatedStyleIDs = {};
  const sleeveGroupUpdates = {};

  profile.items.forEach((item) => {
    const key = item.styleType.toLowerCase().replace(/[\s/]/g, '');
    const style = selectedFabric.styles.find(s => s.styleID === item.styleOptionID);
    if (style) {
      const preview = selectedFabric.previewImages.find(
        (p) =>
          p.styleType.toLowerCase().replace(/[\s/]/g, '') === key &&
          p.styleName === style.styleName
      );
      updatedOptions[key] = preview?.imageURL || style.imageURL;
      updatedStyleIDs[key] = style.styleID;

      if (key === 'cuff') {
        const sleeve = style.sleeveGroup || 'Long';
        sleeveGroupUpdates[key] = sleeve;
      }
    }
  });

  setSelectedProfile(profile.profileName);
  setPendingOptions(prev => ({ ...(prev ?? selectedOptions), ...updatedOptions }));
  setSelectedStyleIDs(prev => ({ ...prev, ...updatedStyleIDs }));
  setSelectedSleeveGroup(prev => ({ ...prev, ...sleeveGroupUpdates }));

  // Force active tab to Cuff if profile contains cuff
  if (profile.items.some(item => item.styleType.toLowerCase().replace(/[\s/]/g, '') === 'cuff')) {
    setActiveStyleType('cuff');
  } else if (profile.items.length > 0) {
    const firstKey = profile.items[0]?.styleType?.toLowerCase().replace(/[\s/]/g, '');
    setActiveStyleType(firstKey);
  }
};

const images = productData?.fabrics?.[selectedFabricIndex]?.images || [];
const hasLoadedPreviewLayers = Object.values(selectedOptions || {}).some(Boolean);

  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">
        <div className="section-container">
          <div className="custom-tabs">
            {['Fabric', 'Styles', 'Sizes', 'Summary'].map((tab) => (
              <button
                key={tab}
                className={`custom-tab-btn ${activeTab === tab ? 'active' : ''}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="left-right-container">
            {/* 🧥 Left Shirt Preview */}
            <div className="left-section" ref={leftSectionRef}>
            <div className={`shirt-container ${isPreviewLoading ? 'loading' : ''}`}>
              {isPreviewLoading && (
  <div className="loading-bar loading-bar--indeterminate">
    <span className="loading-runner"></span>
    <span className="loading-runner loading-runner--delayed"></span>
  </div>
)}
   {!isPreviewLoading && hasLoadedPreviewLayers && ['fabric', ...ALLOWED_STYLES, 'tag'].map((layer) => {
  // {['fabric', ...ALLOWED_STYLES].map((layer) => {
    const src = selectedOptions[layer] || '';

    return (
      <img
        key={layer}
        id={`${layer}-image`}
        className="style-image"
        src={src}
        alt={`${layer.charAt(0).toUpperCase() + layer.slice(1)} Style`}
        style={{ display: src ? 'block' : 'none' }}
      />
    );
  })}
  {collarAccentImage && (
  <img
    id="collar-accent-image"
    className="style-image"
    src={collarAccentImage}
    alt="Collar Accent"
    style={{ display: 'block' }}
  />
)}
{/* ✅ Button overlays for Collar / Cuff / Front (Placket) */}
{['collar', 'cuff', 'front', 'pocket'].map((zone) => {
  const src = buttonOverlayImages[zone];
  return src ? (
    <img
      key={`btn-${zone}`}
      id={`button-overlay-${zone}`}
      className="style-image button-overlay"
      src={src}
      alt={`Buttons on ${zone}`}
      style={{ display: 'block' }}
    />
  ) : null;
})}

{/* ✅ Button-hole overlays for Collar / Cuff / Front / Pocket */}
{['collar', 'cuff', 'front', 'pocket'].map((zone) => {
  const src = buttonHoleOverlayImages[zone];
  return src ? (
    <img
      key={`btnhole-${zone}`}
      id={`button-hole-overlay-${zone}`}
      className="style-image button-hole-overlay"
      src={src}
      alt={`Button holes on ${zone}`}
      style={{ display: 'block' }}
    />
  ) : null;
})}

  {/* ✅ Monogram Overlay Added Here */}
    {isMonogramEnabled && (
      <div className="monogram-circle">
        <div
          className="monogram-circle-bg"
          style={{
            backgroundImage: `url(${productData?.fabrics?.[selectedFabricIndex]?.displayImage || '/assets/images/customProduct/Base_image.png'})`
          }}
        >
          <span
            style={{
              fontFamily:
                monogramStyle === 'Script'
                  ? 'cursive'
                  : monogramStyle === 'Serif'
                  ? 'serif'
                  : 'Arial, sans-serif',
              color: getColorHex(monogramColor)
            }}
          >
            {monogramInitials}
          </span>
        </div>
      </div>
    )}
</div>

            </div>
            
            {/* 🎨 Right Customization Panel */}
            <div className="right-section" ref={rightSectionRef}>
              <div className="custom-tabs-content">

                {/* --- Fabric Tab --- */}
                {activeTab === 'Fabric' && (
                  <div id="fabric-tab" className="custom-tab-content active">
                    <div className="option-boxes" id="fabric-options">
                      {productData.fabrics.map((fabric, index) => (
                        <div
                          key={index}
                          className={`option-box fabric-option ${index === selectedFabricIndex ? 'selected' : ''}`}
                          id="fabric-img"
                          data-image={fabric.displayImage}
                          data-price={`$${fabric.finalPrice}`}
                          data-name={fabric.fabricName}
                          onClick={() => handleFabricSelect(fabric, index)}
                        >
                          <img
                            src={isRightFabricReady ? fabric.displayImage : ''}
                            alt={fabric.fabricName}
                            loading="lazy"
                            decoding="async"
                          />
                          <span className="fabric-name">{fabric.fabricName}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* --- Styles Tab --- */}
                {activeTab === 'Styles' && (

                  <div id="styles-tab" className="custom-tab-content active">
                    {console.log('Style Profiles:', productData.fabrics?.[selectedFabricIndex]?.styleProfiles)}
                    <div className="predefined-style">
                      <p>Style Profile</p>
                      <div className={`custom-style-select ${isStyleDropdownOpen ? 'open' : ''}`}>
                        <div
                          className="custom-select-trigger"
                          onClick={() => setIsStyleDropdownOpen(prev => !prev)}
                        >
                          {selectedProfile}
                        </div>
                        <div className="custom-options">
                          <div
                            className={`custom-option ${selectedProfile === 'No Style Profile Selected' ? 'selected' : ''}`}
                            onClick={() => {
                            const selectedFabric = productData.fabrics[selectedFabricIndex];
                              const defaultStyleIDs = {};
                              const defaultOptions = {};

                              defaultOptions['fabric'] =
                              selectedFabric?.baseLayerImage?.includes('/fabric_base/') && selectedFabric?.baseLayerImage
                                ? selectedFabric.baseLayerImage
                                : '/assets/images/customProduct/_image.png';

                              ALLOWED_STYLES.forEach(styleTypeKey => {
                                const style = selectedFabric.styles.find(s =>
                                  s.styleType.toLowerCase().replace(/[\s/]/g, '') === styleTypeKey
                                );
                                if (style) {
                                  const preview = selectedFabric.previewImages.find(p =>
                                    p.styleType.toLowerCase().replace(/[\s/]/g, '') === styleTypeKey &&
                                    p.styleName === style.styleName
                                  );
                                  defaultOptions[styleTypeKey] = preview?.imageURL || style.imageURL;
                                  defaultStyleIDs[styleTypeKey] = style.styleID;
                                }
                              });

                              setSelectedProfile('No Style Profile Selected');
                              setPendingOptions(defaultOptions);
                              setSelectedStyleIDs(defaultStyleIDs);
                              setIsStyleDropdownOpen(false);
                            }}
                          >
                            No Style Profile Selected
                          </div>
                          <div className="custom-divider"></div>
                          {productData.fabrics?.[selectedFabricIndex]?.styleProfiles?.map(profile => (
                            <div
                              key={profile.profileID}
                              className={`custom-option ${selectedProfile === profile.profileName ? 'selected' : ''}`}
                              onClick={() => {
                                handleStyleProfileSelect(profile);
                                setIsStyleDropdownOpen(false);
                              }}
                            >
                              {profile.profileName} - Style Preset
                            </div>
                          ))}
                        </div>
                      </div>

                    </div>

                    <div className="choose-options-container">
                      <div className="choose-container">
                        {orderedStyleEntries.map(([styleType]) => {
                          const styleTypeKey = styleType.toLowerCase().replace(/[\s/]/g, '');
                          const id = styleTypeKey + '-options';
                          const displayLabel = STYLE_DISPLAY_LABELS[styleTypeKey] || styleType;
                          return (
                            <React.Fragment key={styleType}>
                              <h6
                                className="collapsible-header"
                                data-target={id}
                                onClick={() => setActiveStyleType(styleTypeKey)}
                              >
                                {displayLabel}
                              </h6>
                              <hr />
                            </React.Fragment>
                          );
                        })}
                        <h6
                          className="collapsible-header"
                          data-target="monogram-options"
                          onClick={() => setActiveStyleType('monogram')}
                        >
                          Monogram
                        </h6>
                        <hr />
                        <h6
                          className="collapsible-header"
                          data-target="accent-options"
                          onClick={() => setActiveStyleType('accent')}
                        >
                          Accents
                        </h6>
                        <hr />
                        {postAccentStyleEntries.length > 0 && (
                          <>
                            <button
                              type="button"
                              className="more-options-toggle"
                              onClick={() => setShowAdvancedStyleMenus((prev) => !prev)}
                            >
                              {showAdvancedStyleMenus ? 'Hide Options' : 'More Options'}
                              <span className={`more-options-caret ${showAdvancedStyleMenus ? 'open' : ''}`} aria-hidden="true">^</span>
                            </button>
                            <hr />
                          </>
                        )}
                        {showAdvancedStyleMenus && postAccentStyleEntries.map(([styleType]) => {
                          const styleTypeKey = styleType.toLowerCase().replace(/[\s/]/g, '');
                          const id = styleTypeKey + '-options';
                          const displayLabel = STYLE_DISPLAY_LABELS[styleTypeKey] || styleType;
                          return (
                            <React.Fragment key={styleType}>
                              <h6
                                className="collapsible-header"
                                data-target={id}
                                onClick={() => setActiveStyleType(styleTypeKey)}
                              >
                                {displayLabel}
                              </h6>
                              <hr />
                            </React.Fragment>
                          );
                        })}
                      </div>

                      <div className="options-container">
                        {[...orderedStyleEntries, ...(showAdvancedStyleMenus ? postAccentStyleEntries : [])].map(([styleType, styleList]) => {
                          const styleTypeKey = styleType.toLowerCase().replace(/[\s/]/g, '');
                          const id = styleTypeKey + '-options';
                          const isCuff = styleTypeKey === 'cuff';
                          return (
                            <div key={styleType} className="option">
                              {/* ✅ Add Sleeve Tabs only for Cuff */}
                              {isCuff && activeStyleType === styleTypeKey && (
                                <div className="sleeve-tabs">
                                  <button
                                    className={`sleeve-tab ${selectedSleeveGroup[styleTypeKey] !== 'Short' ? 'active' : ''}`}
                                    data-styletype={styleTypeKey}
                                    data-sleeve="Long"
                                    onClick={() => handleSleeveTabClick(styleTypeKey, 'Long')}
                                  >
                                    Long Sleeve
                                  </button>
                                  <button
                                    className={`sleeve-tab ${selectedSleeveGroup[styleTypeKey] === 'Short' ? 'active' : ''}`}
                                    data-styletype={styleTypeKey}
                                    data-sleeve="Short"
                                    onClick={() => handleSleeveTabClick(styleTypeKey, 'Short')}
                                  >
                                    Short Sleeve
                                  </button>
                                </div>
                              )}
                              <div className="option-boxes collapsible-content" id={id} style={{ display: 'none', gap: '20px' }}>
                                {styleList
                                  .filter(style => {
                                    if (!isCuff) return true;
                                    const sleeveSelected = selectedSleeveGroup[styleTypeKey] || 'Long';
                                    return (style.sleeveGroup || 'Long') === sleeveSelected;
                                  })
                                  .map((style) => {
                                  const key = style.styleType.toLowerCase().replace(/[\s/]/g, '');
                                  return (
                                    <div
                                      key={style.styleID}
                                      className={`option-box ${selectedStyleIDs[key] === style.styleID ? 'selected' : ''}`}
                                      data-type={key}
                                      data-image={style.imageURL}
                                      onClick={() => {
                                        const selectedFabric = productData.fabrics[selectedFabricIndex];

                                        // Try to find a preview image that matches both type and name
                                        const preview = selectedFabric.previewImages.find(
                                            (p) =>
                                            p.styleType.toLowerCase().replace(/[\s/]/g, '') === key &&
                                            p.styleName === style.styleName
                                        );

                                        const previewURL = preview?.imageURL || style.imageURL;

                                        setPendingOptions((prev) => ({ ...(prev ?? selectedOptions), [key]: previewURL }));
                                        setSelectedStyleIDs((prev) => ({ ...prev, [key]: style.styleID }));

                                        // NEW: if collar was chosen, remember its name and, if accent is on,
                                        // try to show the specific accent image for this collar + selected accent fabric
                                        if (key === 'collar') {
                                          setSelectedCollarName(style.styleName);

                                          if (isCollarAccentEnabled && selectedAccentFabricId) {
                                            const url = getAccentImageForCollar(selectedAccentFabricId, style.styleID);
                                            setCollarAccentImage(url || null);
                                          }
                                        }

                                        if (key === 'cuff') {
                                          const sleeveGroup = style.sleeveGroup || 'Long';
                                          setSelectedSleeveGroup(prev => ({ ...prev, [key]: sleeveGroup }));
                                          setActiveStyleType('cuff');
                                        }
                                      }}

                                      
                                    >
                                      <img
                                        src={isRightStylesReady ? style.imageURL : ''}
                                        alt={style.styleName}
                                        loading="lazy"
                                        decoding="async"
                                      />
                                      <span>{style.styleName}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                        {activeStyleType === 'monogram' && (
  <div className="option" id="monogram-options">
    <div className="monogram-toggle" style={{ marginBottom: '15px' }}>
      <button
        type="button"
        onClick={() => setIsMonogramEnabled(prev => !prev)}
        className={`monogram-btn-toggle ${isMonogramEnabled ? 'active' : ''}`}
        style={{
          padding: '10px 16px',
          fontSize: '16px',
          borderRadius: '8px',
          backgroundColor: isMonogramEnabled ? '#000' : '#fff',
          color: isMonogramEnabled ? '#fff' : '#000',
          border: '1px solid #ccc',
          cursor: 'pointer',
          marginBottom: '15px'
        }}
      >
        {isMonogramEnabled ? '✔ Monogram Added (+$10)' : 'Add Monogram (+$10)'}
      </button>
    </div>

    {isMonogramEnabled && (
      <div className="monogram-details" style={{ display: 'grid', gap: '20px' }}>
        <input
          type="text"
          placeholder="Enter Initials (Max 5)"
          maxLength={5}
          value={monogramInitials}
          onChange={(e) => setMonogramInitials(e.target.value.toUpperCase())}
          style={{ padding: '10px', fontSize: '18px', textAlign: 'center', letterSpacing: '2px' }}
        />

        <div>
          <h6>Style</h6>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {['Block', 'Script', 'Serif'].map(style => (
              <button
                key={style}
                type="button"
                className={`monogram-btn ${monogramStyle === style ? 'selected' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  setMonogramStyle(style);
                }}
              >
                {style}
              </button>
            ))}
          </div>
        </div>

        <div>
          <h6>Color</h6>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {['Black', 'White', 'Gray', 'Lt Gray', 'Red', 'Burgundy', 'Brown', 'Gold', 'Yellow', 'Green', 'Navy', 'Royal Blue', 'Lt Blue', 'Pink', 'Lilac'].map(color => (
              <button
                key={color}
                type="button"
                className={`monogram-btn ${monogramColor === color ? 'selected' : ''}`}
                onClick={() => setMonogramColor(color)}
              >
                <span
                  style={{
                    display: 'inline-block',
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    backgroundColor: colorMap[color],
                    marginRight: '8px',
                    border: color === 'White' ? '1px solid #ccc' : 'none'  // to show white on white
                  }}
                ></span>
                {color}
              </button>
            ))}
          </div>
        </div>

        <div>
          <h6>Placement</h6>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {['Left Center Cuff', 'Right Center Cuff', 'Left Pocket', 'Left Stomach', 'Left Shirt Tail', 'Back Inside of Collar'].map(place => (
              <button
                key={place}
                type="button"
                className={`monogram-btn ${monogramPlacement === place ? 'selected' : ''}`}
                onClick={() => setMonogramPlacement(place)}
              >
                {place}
              </button>
            ))}
          </div>
        </div>
      </div>
    )}
  </div>
)}

{activeStyleType === 'accent' && (
  <div className="option" id="accent-options">
    {/* Accent Toggles */}
    <div className="monogram-toggle" style={{ marginBottom: '15px' }}>
      <button
        type="button"
        className={`monogram-btn-toggle ${isCollarAccentEnabled ? 'active' : ''}`}
        style={{
          padding: '10px 16px',
          fontSize: '16px',
          borderRadius: '8px',
          backgroundColor: isCollarAccentEnabled ? '#000' : '#fff',
          color: isCollarAccentEnabled ? '#fff' : '#000',
          border: '1px solid #ccc',
          cursor: 'pointer',
          marginBottom: '15px'
        }}
        onClick={() => {
          // Central effect will pick external vs self accent automatically
          setIsCollarAccentEnabled(prev => !prev);
        }}
      >
        {isCollarAccentEnabled ? '✔ Collar Accent Selected (+$5)' : 'Add Collar Accent (+$5)'}
      </button>

      <button
        type="button"
        className={`monogram-btn-toggle ${isCuffAccentEnabled ? 'active' : ''}`}
        style={{
          padding: '10px 16px',
          fontSize: '16px',
          borderRadius: '8px',
          backgroundColor: isCuffAccentEnabled ? '#000' : '#fff',
          color: isCuffAccentEnabled ? '#fff' : '#000',
          border: '1px solid #ccc',
          cursor: 'pointer',
          marginBottom: '15px',
          marginLeft: '10px'
        }}
        onClick={() => setIsCuffAccentEnabled(prev => !prev)}
      >
        {isCuffAccentEnabled ? '✔ Cuff Accent Selected (+$5)' : 'Add Cuff Accent (+$5)'}
      </button>
    </div>

    {/* Fabric Selector */}
    {(isCollarAccentEnabled || isCuffAccentEnabled) && (
      <div className="option-boxes" id="accent-fabric-options">
        {accentFabrics.map((af) => {
          const currentCollarId = selectedStyleIDs['collar'];
          const availUrl = getAccentImageForCollar(af.fabricID, currentCollarId);
          const available = !!availUrl;

          return (
            <div
              key={af.fabricID}
              className={`option-box ${selectedAccentFabricId === af.fabricID ? 'selected' : ''} ${available ? '' : 'unavailable'}`}
              onClick={() => {
                setSelectedAccentFabricId(af.fabricID);
                // Central effect will resolve the correct image
              }}
              title={available ? '' : `Unavailable for ${selectedCollarName || 'this collar'}`}
              style={{ position: 'relative' }}
            >
              <img src={af.displayImage} alt={af.fabricName} />
              <span>{af.fabricName}</span>

              {/* Hover overlay for unavailable */}
              {!available && (
                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'rgba(0,0,0,0.45)',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontSize: 14,
                    opacity: 0,
                    transition: 'opacity .2s'
                  }}
                  className="accent-unavailable-overlay"
                >
                  Unavailable for {selectedCollarName || 'this collar'}
                </div>
              )}
              <style>{`
                .option-box.unavailable:hover .accent-unavailable-overlay {
                  opacity: 1;
                }
              `}</style>
            </div>
          );
        })}
      </div>
    )}
  </div>
)}


                        <div className="option" id="last-option"></div>
                      </div>
                    </div>
                  </div>
                )}

	{activeTab === 'Sizes' && (
  <div id="sizes-tab" className="custom-tab-content active">
    <h1>Please select a size</h1>
    <button className="guide-btn" onClick={openSizeGuide} style={{ marginBottom: '16px' }}>
      SIZE GUIDE
    </button>

    <div className={`size-overlay ${showSizeGuide ? 'show' : ''}`}>
      <button className="size-close-btn" onClick={closeSizeGuide}>
        ✖
      </button>
      <h3 className="text-center">Size Guide</h3>

      <div className="fit-div">
        <h6>FIT</h6>
        <div>
          {['Slim', 'Classic', 'Athletic'].map((fitOption) => (
            <button
              key={fitOption}
              className={`size-btn ${selectedSizeGuideFit === fitOption ? 'active' : ''}`}
              onClick={() => handleSizeGuideFitChange(fitOption)}
            >
              {fitOption}
            </button>
          ))}
        </div>
      </div>

      <div className="size-table-container">
        <table className="size-table">
          <thead>
            <tr>
              <th>Measurements (in)</th>
              {sizeGuideColumns.map((size) => (
                <th key={size}>{size}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sizeGuideRowLabels.map((label, index) => (
              <tr key={label}>
                <td>{label}</td>
                {sizeGuideColumns.map((_, colIndex) => (
                  <td key={colIndex}>{selectedSizeGuideTableData?.[index]?.[colIndex] ?? '-'}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>

    {/* ✅ Standard Sizes Section */}
    <div className="standard-size-section" style={{ marginBottom: '40px' }}>
      <h2 className="custom-size-title">Standard Sizes</h2>

      <div
        className="standard-size-card"
        style={{
          border: '1px solid #e0e0e0',
          borderRadius: '12px',
          padding: '24px',
          maxWidth: '640px',
          boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
          marginBottom: '24px'
        }}
      >
        {/* Collar */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ fontSize: '0.78rem', letterSpacing: '0.12em', fontWeight: 600, marginBottom: '12px' }}>
            COLLAR SIZE
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
              gap: '12px'
            }}
          >
            {COLLAR_OPTIONS.map(opt => {
              const active = standardSize.collarSize === opt.value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => handleStandardSelect('collarSize', opt.value)}
                  style={{
                    borderRadius: '6px',
                    border: active ? '2px solid #000' : '1px solid #d0d0d0',
                    backgroundColor: active ? '#3d4048' : '#fff',
                    color: active ? '#fff' : '#111',
                    padding: '10px 8px',
                    fontSize: '0.95rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: active ? '0 0 0 3px rgba(0,0,0,0.15)' : 'none',
                    cursor: 'pointer'
                  }}
                >
                  <span>{opt.value}</span>
                  <span style={{ fontSize: '0.7rem', color: active ? '#e0e0e0' : '#888', marginTop: '4px' }}>
                    {opt.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Sleeve */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ fontSize: '0.78rem', letterSpacing: '0.12em', fontWeight: 600, marginBottom: '12px' }}>
            SLEEVE LENGTH
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
              gap: '12px'
            }}
          >
            {sleeveOptionsForCurrentCollar.map(opt => {
              const active = standardSize.sleeveLength === opt.value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => handleStandardSelect('sleeveLength', opt.value)}
                  style={{
                    borderRadius: '6px',
                    border: active ? '2px solid #000' : '1px solid #d0d0d0',
                    backgroundColor: active ? '#3d4048' : '#fff',
                    color: active ? '#fff' : '#111',
                    padding: '10px 8px',
                    fontSize: '0.95rem',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: active ? '0 0 0 3px rgba(0,0,0,0.15)' : 'none',
                    cursor: 'pointer'
                  }}
                >
                  <span>{opt.value}</span>
                  <span style={{ fontSize: '0.7rem', color: active ? '#e0e0e0' : '#888', marginTop: '4px' }}>
                    {opt.label}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Fit */}
        <div style={{ marginBottom: '24px' }}>
          <div style={{ fontSize: '0.78rem', letterSpacing: '0.12em', fontWeight: 600, marginBottom: '12px' }}>
            FIT
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
              gap: '12px'
            }}
          >
            {FIT_OPTIONS.map(opt => {
              const active = standardSize.fit === opt.value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  onClick={() => handleStandardSelect('fit', opt.value)}
                  style={{
                    borderRadius: '6px',
                    border: active ? '2px solid #000' : '1px solid #d0d0d0',
                    backgroundColor: active ? '#3d4048' : '#fff',
                    color: active ? '#fff' : '#111',
                    padding: '10px 8px',
                    fontSize: '0.9rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: active ? '0 0 0 3px rgba(0,0,0,0.15)' : 'none',
                    cursor: 'pointer'
                  }}
                >
                  {opt.label}
                </button>
              );
            })}
          </div>
        </div>

        <button
          type="button"
          className="rbt-btn btn-gradient"
          onClick={handleSaveStandardSize}
        >
          Save Standard Size
        </button>
      </div>

      {/* Saved standard sizes with radio */}
      {standardSizeList.length > 0 && (
        <div className="rbt-my-account-table table-responsive text-center">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Select</th>
                <th>Collar</th>
                <th>Sleeve</th>
                <th>Fit</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {standardSizeList.map(ss => (
                <tr key={ss.standardSizeSelectionId}>
                  <td>
                    <input
                      type="radio"
                      name="sizeSelection"
                      className="size-radio"
                      checked={
                        selectedSizeType === 'standard' &&
                        selectedSizeId === ss.standardSizeSelectionId
                      }
                      onChange={() => {
                        setSelectedSizeType('standard');
                        setSelectedSizeId(ss.standardSizeSelectionId);
                        setShowSizePanel(false);

                        // ✅ persist guest selection
                        if (!numericUserId) {
                          setGuestSelectedSize({
                            sizeType: 'standard',
                            sizeId: ss.standardSizeSelectionId,
                            standardSizeData: ss
                          });
                        }
                      }}
                    />
                  </td>
                  <td>{ss.collarSize || '-'}</td>
                  <td>{ss.sleeveLength || '-'}</td>
                  <td>{ss.fit || '-'}</td>
                  <td>
                    <button
                      className="rbt-btn btn-gradient btn-sm"
                      onClick={() => handleEditStandardSize(ss)}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>

    <div className="custom-size-selection">
      <h2 className="custom-size-title">Smart Sizes</h2>

      {/* Conditionally render Smart Sizes list or Create box */}
      {smartSizes.length > 0 ? (
        <div className="rbt-smart-sizes-section">
          <div className="rbt-smart-sizes-header">
            <h3>Saved Smart Sizes</h3>
            <div className="rbt-smart-sizes-tabs">
              <button className="rbt-tab active">Shirts</button>
            </div>
            <button
              type="button"
              className="rbt-new-size-btn"
              onClick={() => {
                sessionStorage.setItem(SESSION_RETURN_KEY, location.pathname + location.search + location.hash);
                navigate(`/smartSizes/new/${user?.userId || 0}`);
              }}
            >
              + Create a New Size
            </button>
          </div>

          <div className="rbt-smart-sizes-list" id="rbt-tab-content">
            {smartSizes.map((size, i) => (
              <div className="rbt-size-item" key={size.smartSizeId}>
                <label className="rbt-radio-wrap">
                  <input
                    type="radio"
                    name="sizeSelection"
                    checked={selectedSizeType === 'smart' && selectedSizeId === size.smartSizeId}
                    onChange={() => {
                      setSelectedSizeType('smart');
                      setSelectedSizeId(size.smartSizeId);
                      setShowSizePanel(false);
                    }}
                    className="size-radio"
                  />
                  
                </label>
                <div className="rbt-size-info">
                  <strong>Smart Sizes – {size.name || `Size ${i + 1}`}</strong>
                  
                </div>
                <button className="rbt-edit-btn" onClick={() => handleEditSmartSize(size)}>
                  View / Edit
                </button>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="custom-smart-size-box">
          <div className="custom-smart-header">
            <h3 className="custom-smart-title">Smart Sizes</h3>
            <span className="custom-popular-tag">Most Popular</span>
          </div>
          <p className="custom-smart-description">
            Answer a few simple questions about your body and let our algorithms calculate your ideal custom size.
            Smart Sizes is based on millions of customer data points and is incredibly accurate.
          </p>
          <button
            type="button"
            className="custom-smart-button"
            onClick={() => {
              sessionStorage.setItem(SESSION_RETURN_KEY, location.pathname + location.search + location.hash);
              navigate(`/smartSizes/new/${user?.userId || 0}`);
            }}
          >
            USE SMART SIZES
          </button>
        </div>
      )}

      {/* OR Separator */}
      <div className="custom-or">OR</div>

      {/* Alternative Size Selection */}
      <ul className="custom-size-options">
        <li id="measureBodyBtn">
          <h3 className="custom-size-title">Measure Your Body</h3>

            <p style={{ marginTop: '10px', color: '#555' }}>
              Provide your actual body measurements to ensure a perfect tailored fit.
            </p>

            <button
              className="rbt-btn btn-gradient mt--20"
              onClick={() => {
                setEditingBodyMeasurement(null);
                setShowMeasurePopup(true);
              }}
            >
              + Add Measurement
            </button>

            <div className="rbt-my-account-table table-responsive text-center mt--30">
              {bodyMeasurements.length === 0 ? (
                <div style={{
                  padding: '2rem',
                  border: '1px solid #e0e0e0',
                  borderRadius: '12px',
                  backgroundColor: '#f9f9f9',
                  textAlign: 'center'
                }}>
                  <h4 style={{ fontWeight: '600', fontSize: '1.5rem', marginBottom: '1rem', color: '#333' }}>
                    No Body Measurements Saved
                  </h4>
                  <p style={{ color: '#777', lineHeight: '1.6' }}>
                    To ensure your shirts fit perfectly, please add your body measurements.
                  </p>
                </div>
              ) : (
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Select</th>
                      <th>Neck</th>
                      <th>Sleeve</th>
                      <th>Chest</th>
                      <th>Fit</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bodyMeasurements.map(measure => (
                      <tr key={measure.bodyMeasurementId}>
                        <td>
                          <input
                            type="radio"
                            name="sizeSelection"
                            checked={selectedSizeType === 'body' && selectedSizeId === measure.bodyMeasurementId}
                            onChange={() => {
                              setSelectedSizeType('body');
                              setSelectedSizeId(measure.bodyMeasurementId);
                              setShowSizePanel(false);
                            }}
                            className="size-radio"
                          />
                        </td>
                        <td>{measure.neckAround ?? '-'}</td>
                        <td>{measure.sleeveLength ?? '-'}</td>
                        <td>{measure.chestAround ?? '-'}</td>
                        <td>{measure.fit ? measure.fit.charAt(0).toUpperCase() + measure.fit.slice(1) : '-'}</td>
                        <td>
                          <button
                            onClick={() => {
                              setEditingBodyMeasurement(measure);
                              setShowMeasurePopup(true);
                            }}
                            className="rbt-btn btn-gradient btn-sm"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDeleteBodyMeasurement(measure.bodyMeasurementId)}
                            className="rbt-btn btn-danger btn-gradient btn-sm ms--10"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
        </li>
        <li id="measureShirtBodyBtn" onClick={() => setShowMeasureShirtPopup(true)}>
          <h3 className="custom-size-title">Measure a Shirt</h3>

          <p style={{ marginTop: '10px', color: '#555' }}>
            Add measurements from your favorite well-fitting shirt to help us create a perfect replica tailored to your preferences.
          </p>

          <button
            className="rbt-btn btn-gradient mt--20"
            onClick={() => {
              setSelectedShirtMeasurement(null);
              setShirtForm({
                collarAround: '',
                sleeveLength: '',
                yokeWidth: '',
                chestWidth: '',
                midsectionWidth: '',
                shirtLength: '',
                sleeveWidth: '',
                cuffAround: ''
              });
              setShowShirtPopup(true);
            }}
          >
            + Add Shirt Measurement
          </button>

          <div className="rbt-my-account-table table-responsive text-center mt--30">
            {shirtMeasurements.length === 0 ? (
              <div style={{ padding: '2rem', border: '1px solid #ddd', borderRadius: '12px', backgroundColor: '#f9f9f9' }}>
                <h4 style={{ fontWeight: '600', fontSize: '1.5rem', marginBottom: '1rem', color: '#333' }}>
                  No Shirt Measurements Saved
                </h4>
                <p style={{ color: '#777', lineHeight: '1.6' }}>
                  To ensure the perfect replica of your favorite shirt, please add shirt measurements.
                </p>
              </div>
            ) : (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Collar</th>
                    <th>Sleeve</th>
                    <th>Chest</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {shirtMeasurements.map(measure => (
                    <tr key={measure.shirtMeasurementId}>
                      <td>
                        <input
                          type="radio"
                          name="sizeSelection"
                          checked={selectedSizeType === 'shirt' && selectedSizeId === measure.shirtMeasurementId}
                          onChange={() => {
                            setSelectedSizeType('shirt');
                            setSelectedSizeId(measure.shirtMeasurementId);
                            setShowSizePanel(false);
                          }}
                          className="size-radio"
                        />
                      </td>
                      <td>{measure.collarAround ?? '-'}</td>
                      <td>{measure.sleeveLength ?? '-'}</td>
                      <td>{measure.chestWidth ?? '-'}</td>
                      <td>
                        <button
                          onClick={() => {
                            setSelectedShirtMeasurement(measure);
                            setShirtForm({
                              collarAround: measure.collarAround ?? '',
                              sleeveLength: measure.sleeveLength ?? '',
                              yokeWidth: measure.yokeWidth ?? '',
                              chestWidth: measure.chestWidth ?? '',
                              midsectionWidth: measure.midsectionWidth ?? '',
                              shirtLength: measure.shirtLength ?? '',
                              sleeveWidth: measure.sleeveWidth ?? '',
                              cuffAround: measure.cuffAround ?? ''
                            });
                            setShowShirtPopup(true);
                          }}
                          className="rbt-btn btn-gradient btn-sm"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDeleteShirtMeasurement(measure.shirtMeasurementId)}
                          className="rbt-btn btn-danger btn-gradient btn-sm ms--10"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>

        </li>
        <li>
          <div className="size-section">
            <h3 className="custom-size-title">Mail us a Shirt to Measure</h3>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              
              <input
                type="radio"
                name="sizeSelection"
                checked={selectedSizeType === 'mail'}
                onChange={() => {
                  setSelectedSizeType('mail');
                  setSelectedSizeId('mail');
                  setShowSizePanel(false);
                }}
                className="size-radio"
              />
              <span style={{ fontWeight: '500', color: '#333' }}>Shirt Mailed to Measure</span>
            </div>

            <p style={{ marginTop: '10px', color: '#555' }}>
              Want to copy the fit of a shirt you already have, but aren’t sure how to measure it properly?
            </p>
            <p style={{ color: '#555' }}>
              Mail us your shirt and our experts will measure it and create a special saved size in your account for you.
              <br />
              <em>*Note that our measuring causes no damage to the shirt and we will return the shirt to you right away.</em>
            </p>

            <h5 style={{ margin: '15px 0 10px', fontWeight: '600' }}>Send to:</h5>
            <div style={{ border: '1px solid #ddd', borderRadius: '8px', padding: '15px', background: '#f9f9f9' }}>
              <p style={{ margin: 0 }}><strong>Capital Custom Clothier</strong></p>
              <p style={{ margin: 0 }}>Attn: Measuring</p>
              <p style={{ margin: 0 }}>50 Maryland Ave</p>
              <p style={{ margin: 0 }}>Annapolis, MD 21401</p>
            </div>

            <h5 style={{ margin: '15px 0 10px', fontWeight: '600' }}>When sending, be sure to include:</h5>
            <ul style={{ paddingLeft: '20px', lineHeight: '1.6', color: '#555' }}>
              <li>The shirt you want us to measure</li>
              <li>Your name</li>
              <li>Phone number</li>
              <li>Email address</li>
              <li>Return shipping address</li>
              <li>Any special instructions</li>
            </ul>
          </div>
        </li>

      </ul>
    </div>
    <div className="option" id="last-option"></div>
    </div>
    )}



                {activeTab === 'Summary' && (
                <div id="summary-tab" className="custom-tab-content active">
                    <div className="product-summary-container">
                    <h2 className="product-summary-title">{productData?.productName}</h2>
                    <p className="product-summary-price">${productPrice}</p>

                    <div className="product-summary-buttons">
                        <button className="product-summary-add" onClick={handleAddToCart}>Add to Bag</button>
                        <button className="product-summary-add" onClick={handleAddToWishlist}>Add to Wishlist</button>
                    </div>

                    <div className="product-summary-section">
                      <label>Fabric</label>
                      <div className="product-summary-tag">
                        {productData.fabrics?.[selectedFabricIndex]?.fabricName || 'No fabric selected'}
                      </div>
                    </div>

                    <div className="product-summary-section">
                      <label>Style</label>
                      <div className="product-summary-tags">
                        {Object.entries(selectedStyleIDs).map(([key, id]) => {
                          const fabric = productData.fabrics[selectedFabricIndex];
                          const match = fabric?.styles?.find(style => style.styleID === id);
                          return match ? (
                            <div key={id} className="product-summary-tag">
                              {match.styleName}
                            </div>
                          ) : null;
                        })}
                      </div>
                    </div>

                    <div className="product-summary-section">
                      <label>Monogram</label>
                      {isMonogramEnabled ? (
                        <div className="product-summary-tags">
                          <div className="product-summary-tag">Initials: {monogramInitials || 'N/A'}</div>
                          <div className="product-summary-tag">Style: {monogramStyle}</div>
                          <div className="product-summary-tag">Color: {monogramColor}</div>
                          <div className="product-summary-tag">Placement: {monogramPlacement}</div>
                        </div>
                      ) : (
                        <div className="product-summary-tag">None</div>
                      )}
                    </div>

                    <div className="product-summary-section">
                      <label>Accents</label>
                      {(isCollarAccentEnabled || isCuffAccentEnabled) ? (
                        <div className="product-summary-tags">
                          {isCollarAccentEnabled && (
                            <div className="product-summary-tag">Collar Accent: Enabled (+$5)</div>
                          )}
                          {isCuffAccentEnabled && (
                            <div className="product-summary-tag">Cuff Accent: Enabled (+$5)</div>
                          )}
                          {selectedAccentFabricId && (
                            <div className="product-summary-tag">
                              Accent Fabric: {
                                accentFabrics.find(f => f.fabricID === selectedAccentFabricId)?.fabricName || '—'
                              }
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="product-summary-tag">None</div>
                      )}
                    </div>


                    <div className="product-summary-section">
  <label>Size</label>
  <div className="product-summary-tag">
    {selectedSizeType === 'standard' && standardSizeList.find(s => s.standardSizeSelectionId === selectedSizeId)
      ? (() => {
          const ss = standardSizeList.find(s => s.standardSizeSelectionId === selectedSizeId);
          return `Standard Size – Collar ${ss.collarSize || '-'}, Sleeve ${ss.sleeveLength || '-'}, ${ss.fit || '-'}`;
        })()
      : selectedSizeType === 'smart' && smartSizes.find(s => s.smartSizeId === selectedSizeId)
      ? `Smart Size – ${smartSizes.find(s => s.smartSizeId === selectedSizeId)?.name || 'Unnamed'}`
      : selectedSizeType === 'body' && bodyMeasurements.find(b => b.bodyMeasurementId === selectedSizeId)
      ? 'Body Measurement Selected'
      : selectedSizeType === 'shirt' && shirtMeasurements.find(s => s.shirtMeasurementId === selectedSizeId)
      ? 'Shirt Measurement Selected'
      : selectedSizeType === 'mail'
      ? 'Mail Us a Shirt'
      : 'No Size Selected'}
  </div>
</div>


                    <div className="product-summary-footer">
                        <div className="product-summary-footer-box">
                        <span role="img" aria-label="package">📦</span>
                        <p>
                          {deliveryEstimate
                            ? `Order today for delivery to the US or Canada by ${deliveryEstimate}`
                            : 'Estimated delivery date will appear here.'}
                        </p>
                        </div>
                        <div className="product-summary-footer-box">
                        <span role="img" aria-label="sparkles">✨</span>
                        <p>Complimentary remakes on your first shirt with our <a href="/perfect-fit">Perfect Fit Guarantee</a>.</p>
                        </div>
                    </div>
                    </div>
                </div>
                )}

                {/* ✅ Fixed Bottom Section */}
<div className="bottom-bar">
  <button id="open-detail-popup" onClick={() => {
    setCurrentSlideIndex(0);  // ✅ Reset to first image each time
    setIsPopupOpen(true);
  }}>
    Details
  </button>

  {isPopupOpen && (
    <div
      id="detail-popup"
      className="detail-popup-overlay"
      onClick={(e) => {
        if (e.target.id === 'detail-popup') setIsPopupOpen(false);
      }}
    >
      <div className="detail-popup-content">
        <button className="detail-popup-close" onClick={() => setIsPopupOpen(false)}>
          &times;
        </button>

        <div className="detail-popup-body">
          {/* ✅ Left: Dynamic Image Slider */}
          <div className="detail-popup-slider">
            <Swiper
              modules={[Navigation]}
              navigation={{
                nextEl: '.detail-popup-next',
                prevEl: '.detail-popup-prev',
              }}
              loop={true}
              spaceBetween={10}
              slidesPerView={1}
              className="detail-popup-slider-container"
            >
              {images.length > 0 ? (
                images.map((img, index) => (
                  <SwiperSlide key={index}>
                    <div className="detail-popup-slide">
                      <img src={img.imageURL} alt={`Fabric ${index + 1}`} />
                    </div>
                  </SwiperSlide>
                ))
              ) : (
                <SwiperSlide>
                  <div className="detail-popup-slide">
                    <img src="/assets/images/customProduct/_image.png" alt="No Image" />
                  </div>
                </SwiperSlide>
              )}
            </Swiper>

            <button className="detail-popup-prev">&lt;</button>
            <button className="detail-popup-next">&gt;</button>
          </div>

          {/* ✅ Right: Dynamic Fabric Details */}
          <div className="detail-popup-text">
            {/* Top: Name, Price, Code */}
            <h2 className="fabric-title">
              {productData?.fabrics?.[selectedFabricIndex]?.fabricName || 'Fabric Name'}
            </h2>
            <p className="fabric-price">
              ${productData?.fabrics?.[selectedFabricIndex]?.basePrice?.toFixed(2) || '0.00'}
            </p>
            <p className="fabric-code">
              {productData?.fabrics?.[selectedFabricIndex]?.fabricCustomID || '—'}
            </p>

            {/* Middle: Two Column Fabric Details */}
            <div className="fabric-details-grid">
              <div className="fabric-details-col">
                <p><strong>Suggested Style:</strong><br />{productData?.fabrics?.[selectedFabricIndex]?.suggestedStyle || '—'}</p>
                <p><strong>Weave:</strong><br />{productData?.fabrics?.[selectedFabricIndex]?.weave || '—'}</p>
                <p><strong>Composition:</strong><br />{productData?.fabrics?.[selectedFabricIndex]?.composition || '—'}</p>
                <p><strong>Thread Count:</strong><br />{productData?.fabrics?.[selectedFabricIndex]?.threadCount || '—'}</p>
                <p><strong>Weight:</strong><br />{productData?.fabrics?.[selectedFabricIndex]?.weight ? `${productData.fabrics[selectedFabricIndex].weight}` : '—'}</p>
              </div>

              <div className="fabric-details-col">
                <p><strong>Opacity:</strong><br />{productData?.fabrics?.[selectedFabricIndex]?.opacityRating || '—'} / 5</p>
                <p><strong>Wrinkle Resistance:</strong><br />{productData?.fabrics?.[selectedFabricIndex]?.wrinkleResistance || '—'} / 5</p>
                <p><strong>Care Instructions:</strong><br />{productData?.fabrics?.[selectedFabricIndex]?.careInstructions || '—'}</p>
                <p><strong>Customizable:</strong><br />{productData?.fabrics?.[selectedFabricIndex]?.isCustomizable ? 'Yes' : 'No'}</p>
                <p><strong>Rating:</strong><br />⭐⭐⭐⭐⭐ (4.8/5)</p>
              </div>
            </div>

            {/* Bottom: Description */}
            <div className="fabric-description">
              <p>{productData?.description || 'No description available.'}</p>
            </div>

            {/* Optional Tags */}
            {productData?.tags?.length > 0 && (
              <div className="fabric-tags">
                <strong>Tags:</strong> {productData.tags.map(tag => tag.name).join(', ')}
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  )}




  <button className="prev-btn" onClick={goToPrevTab} disabled={activeTab === tabSequence[0]}>
    Prev
  </button>

  <div className="fabric-details">
    <span className="selected-fabric-name">
      {productData?.productName || 'Select a Product'}
    </span>
    <span className="selected-fabric-price">${productPrice}</span>
  </div>

  <button className="next-btn" onClick={goToNextTab} disabled={activeTab === tabSequence[tabSequence.length - 1]}>
    Next
  </button>
</div>


              </div>
            </div>

          </div>
        </div>

        {/* Measure Your Body Popup */}
{showMeasurePopup && (
  <div className="measure-popup-overlay show-measure-popup">
    <div className="measure-popup-content">
      <span
        className="measure-close-btn"
        onClick={() => {
          setShowMeasurePopup(false);
          setEditingBodyMeasurement(null);
        }}
      >
        &times;
      </span>

      <div className="measure-popup-grid">
        <div className="measure-popup-left">
          <h3>{editingBodyMeasurement ? 'Edit Body Measurement' : 'Measure Your Body'}</h3>

          <form onSubmit={handleSaveBodyMeasurement}>
            {[
              { key: 'neckAround', label: 'Neck Around' },
              { key: 'sleeveLength', label: 'Sleeve Length' },
              { key: 'shoulderWidth', label: 'Shoulder Width' },
              { key: 'chestAround', label: 'Chest Around' },
              { key: 'waistAround', label: 'Waist Around' },
              { key: 'shirtLength', label: 'Shirt Length' },
              { key: 'bicepAround', label: 'Bicep Around' },
              { key: 'wristAround', label: 'Wrist Around' },
            ].map((field) => (
              <React.Fragment key={field.key}>
                <label>{field.label}</label>
                <div className="measure-input-group">
                  <input
                    type="number"
                    name={field.key}
                    defaultValue={editingBodyMeasurement?.[field.key] ?? ''}
                    required
                    onFocus={() => setActiveBodyField(field.key)}
                    onClick={() => setActiveBodyField(field.key)}
                  />
                  <span>in</span>
                </div>
              </React.Fragment>
            ))}

            <label>Fit</label>
            <select name="fit" defaultValue={editingBodyMeasurement?.fit || 'slim'}>
              <option value="slim">Slim</option>
              <option value="regular">Regular</option>
              <option value="loose">Loose</option>
            </select>

            <button type="submit" className="measure-done-btn">
              {editingBodyMeasurement ? 'Save Changes' : 'Done, Create Size'}
            </button>
          </form>
        </div>

        <div className="measure-popup-right">
          <h2>{BODY_FIELD_LABELS[activeBodyField] || 'Measurement Tips'}</h2>
          <p>Select a measurement field on the left to see how to measure it correctly.</p>

          {getBodyVideoUrl() ? (
            <iframe
              title="Body Measurement Video"
              width="100%"
              height="50%"
              src={getBodyVideoUrl()}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div
              style={{
                padding: '12px',
                border: '1px solid #e5e5e5',
                borderRadius: '8px',
                background: '#fafafa',
              }}
            >
              No video available for this measurement.
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)}

{/* Measure a Shirt Popup (same pattern as ProductDetails) */}
{showShirtPopup && (
  <div className="measure-popup-overlay show-measure-popup">
    <div className="measure-popup-content">
      <span
        className="measure-close-btn"
        onClick={() => {
          setShowShirtPopup(false);
          setSelectedShirtMeasurement(null);
          setActiveShirtField('collarAround');
        }}
      >
        &times;
      </span>

      <div className="measure-popup-grid">
        <div className="measure-popup-left">
          <h3>{selectedShirtMeasurement ? 'Edit Shirt Measurement' : 'Measure a Shirt'}</h3>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSaveShirtMeasurement();
            }}
          >
            {[
              { key: 'collarAround', label: 'Collar Around' },
              { key: 'sleeveLength', label: 'Sleeve Length' },
              { key: 'yokeWidth', label: 'Yoke Width' },
              { key: 'chestWidth', label: 'Chest Width' },
              { key: 'midsectionWidth', label: 'Midsection Width' },
              { key: 'shirtLength', label: 'Shirt Length' },
              { key: 'sleeveWidth', label: 'Sleeve Width' },
              { key: 'cuffAround', label: 'Cuff Around' },
            ].map((field) => (
              <React.Fragment key={field.key}>
                <label>{field.label}</label>
                <div className="measure-input-group">
                  <input
                    type="number"
                    value={shirtForm[field.key] ?? ''}
                    onChange={(e) =>
                      setShirtForm((prev) => ({ ...prev, [field.key]: e.target.value }))
                    }
                    required
                    onFocus={() => setActiveShirtField(field.key)}
                    onClick={() => setActiveShirtField(field.key)}
                  />
                  <span>in</span>
                </div>
              </React.Fragment>
            ))}

            <button type="submit" className="measure-done-btn">
              {selectedShirtMeasurement ? 'Save Changes' : 'Done, Create Size'}
            </button>
          </form>
        </div>

        <div className="measure-popup-right">
          <h2>{SHIRT_FIELD_LABELS[activeShirtField] || 'Measurement Tips'}</h2>
          <p>Select a measurement field on the left to see how to measure it correctly.</p>

          {getShirtVideoUrl() ? (
            <iframe
              title="Shirt Measurement Video"
              width="100%"
              height="50%"
              src={getShirtVideoUrl()}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div
              style={{
                padding: '12px',
                border: '1px solid #e5e5e5',
                borderRadius: '8px',
                background: '#fafafa',
              }}
            >
              No video available for this measurement.
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)}


      </main>
      <div className="rbt-progress-parent">
        <svg className="rbt-back-circle svg-inner" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>
    </>
  );
};

export default Customize;
